import './App.css'
import React, { useState, useEffect, useRef } from 'react'
import { ethers } from 'ethers'
import nacl from 'tweetnacl'
import naclUtil from 'tweetnacl-util'
import ForumAboABI from './ForumAbo.json'
import { useAppKit, useAppKitAccount, useAppKitProvider, useDisconnect } from '@reown/appkit/react'

import Gun from 'gun/gun'
require('gun/lib/webrtc')
var gun = Gun({
  peers: [
    'https://gun-relay-zonefree_33603.app.runonflux.io/gun',
    'https://gun-relay-blabla_38270.app.runonflux.io/gun'
  ]
})

var CONTRACT_ADDRESS = '0xdb410a6dfcb8fe8f78b7b2783bb674ca0af114bd'
var TOPICS_PAR_PAGE = 5
var SUPER_ADMIN = '0xb4A7D8a91F80cCE5C4B7C9E16a1315101c89A12d'


var FORUMS_INIT = [
  {
    id: 'general', emoji: '💬', name: 'General',
    description: 'Free discussions, daily news',
    creator: '0xb4A7D8a91F80cCE5C4B7C9E16a1315101c89A12d',
    topics: [
      { id: 1, title: 'Welcome to Blabla.Privacy! Introduce yourself', author: 'Admin', pinned: true, replies: [{ id: 1, author: '0xA1B2...C3D4', content: 'Hello everyone!', date: '03/01/2026' }, { id: 2, author: '0xE5F6...G7H8', content: 'Glad to be here!', date: '03/01/2026' }], date: '03/01/2026' },
      { id: 2, title: 'Blabla.Privacy community rules', author: 'Admin', pinned: true, replies: [], date: '03/01/2026' },
      { id: 3, title: 'What do you think of free speech in 2026?', author: '0xA1B2...C3D4', pinned: false, replies: [], date: '03/01/2026' }
    ]
  },
  {
    id: 'crypto', emoji: '₿', name: 'Crypto',
    description: 'Bitcoin, Ethereum, DeFi, Web3',
    creator: '0xb4A7D8a91F80cCE5C4B7C9E16a1315101c89A12d',
    topics: [
      { id: 1, title: 'Bitcoin 100k — Technical market analysis', author: '0xF3E2...1A2B', pinned: false, replies: [], date: '02/28/2026' },
      { id: 2, title: 'DeFi vs Traditional Finance — The debate', author: '0xC9D8...5E6F', pinned: false, replies: [], date: '02/27/2026' },
      { id: 3, title: 'Monero vs Zcash — Which crypto is most private?', author: '0xB7A6...9C0D', pinned: false, replies: [], date: '03/01/2026' },
      { id: 4, title: 'Is Ethereum mainnet still relevant?', author: '0xE5F4...3G4H', pinned: false, replies: [], date: '03/01/2026' }
    ]
  },
  {
    id: 'tech', emoji: '💻', name: 'Tech',
    description: 'Technology, AI, software, hardware',
    creator: '0xb4A7D8a91F80cCE5C4B7C9E16a1315101c89A12d',
    topics: [
      { id: 1, title: 'Best open-source AI in 2026', author: '0xD3C2...7I8J', pinned: false, replies: [], date: '03/01/2026' },
      { id: 2, title: 'Linux vs Windows — Which OS for privacy?', author: '0xH1G0...5K6L', pinned: false, replies: [], date: '02/28/2026' },
      { id: 3, title: 'Project: build your own Ethereum node', author: '0xJ9I8...3M4N', pinned: false, replies: [], date: '03/01/2026' }
    ]
  },
  {
    id: 'politique', emoji: '🏛️', name: 'Politics',
    description: 'Political debates, world geopolitics',
    creator: '0xb4A7D8a91F80cCE5C4B7C9E16a1315101c89A12d',
    topics: [
      { id: 1, title: 'Internet censorship — World tour of restrictions', author: '0xL7K6...1O2P', pinned: false, replies: [], date: '03/01/2026' },
      { id: 2, title: 'CBDC state digital currency, good or bad idea?', author: '0xN5M4...9Q0R', pinned: false, replies: [], date: '02/27/2026' },
      { id: 3, title: 'Elections and social media — opinion manipulation?', author: '0xP3O2...7S8T', pinned: false, replies: [], date: '02/28/2026' }
    ]
  },
  {
    id: 'journaliste', emoji: '📰', name: 'Journalist',
    description: 'Free media, investigations, independent press',
    creator: '0xb4A7D8a91F80cCE5C4B7C9E16a1315101c89A12d',
    topics: [
      { id: 1, title: 'How to publish anonymously in 2026 — Complete guide', author: '0xR1Q0...5U6V', pinned: false, replies: [], date: '03/01/2026' },
      { id: 2, title: 'Independent journalist tools: Tor, Signal, etc.', author: '0xT9S8...3W4X', pinned: false, replies: [], date: '02/28/2026' }
    ]
  }
]

// ─── MIGRATION PSEUDO ───
function getPseudoFromStorage() {
  // 1. Cherche d'abord dans la nouvelle clé
  var stored = localStorage.getItem('zonefree-pseudo') || ''

  // 2. Fallback sur l'ancienne clé 'pseudo' (migration)
  if (!stored) {
    var oldStored = localStorage.getItem('pseudo') || ''
    if (oldStored) {
      stored = oldStored
      // Nettoie l'ancienne clé après migration
      localStorage.removeItem('pseudo')
    }
  }

  if (!stored) return ''

  try {
    var parsed = JSON.parse(stored)
    if (typeof parsed === 'object' && parsed !== null) {
      var valeur = String(Object.values(parsed)[0] || '')
      localStorage.setItem('zonefree-pseudo', valeur)
      return valeur
    }
    return stored
  } catch (e) {
    var match = stored.match(/"([^"]+)"[:\s]*"?([^"{}]+)"?/)
    if (match && match[2]) {
      var valeurMatch = match[2].trim()
      localStorage.setItem('zonefree-pseudo', valeurMatch)
      return valeurMatch
    }
    if (stored.startsWith('{') || stored.startsWith('[')) {
      localStorage.setItem('zonefree-pseudo', '')
      return ''
    }
    return stored
  }
}

class MessagerieErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null } }
  static getDerivedStateFromError(error) { return { hasError: true, error: error.message } }
  render() {
    var self = this
    if (this.state.hasError) return (
      <div style={{ padding: 20, color: '#ef4444', textAlign: 'center' }}>
        Messaging error: {this.state.error}
        <br /><button onClick={function() { self.setState({ hasError: false }) }} style={{ marginTop: 12, padding: '8px 16px', cursor: 'pointer' }}>Retry</button>
      </div>
    )
    return this.props.children
  }
}

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }
  static getDerivedStateFromError(err) {
    return { error: err }
  }
  render() {
    if (this.state.error) {
      return React.createElement('div', {
        style: { position:'fixed', top:0, left:0, right:0, bottom:0,
                 background:'#1a0000', color:'#ff6b6b', padding:20,
                 fontFamily:'monospace', fontSize:12, overflow:'auto', zIndex:99999 }
      },
        React.createElement('h2', null, '🔴 CRASH DETECTED'),
        React.createElement('pre', null, this.state.error && this.state.error.toString()),
        React.createElement('pre', null, this.state.error && this.state.error.stack),
        React.createElement('button', {
          onClick: function() { window.location.reload() },
          style: { marginTop:20, padding:'10px 20px', cursor:'pointer' }
        }, 'Reload')
      )
    }
    return this.props.children
  }
}

function App() {
  // ─── REOWN APPKIT HOOKS ───
  var { open: openModal } = useAppKit()
  var { isConnected, address } = useAppKitAccount()
  var { walletProvider } = useAppKitProvider('eip155')
  var { disconnect } = useDisconnect()

  var disconnectAll = async function() {
    try { await disconnect() } catch(e) {}
    try { cleanupGunListeners() } catch (e) {}
    try {
      Object.keys(localStorage).forEach(function(k) {
        if (k.indexOf('znf-nacl-') === 0) localStorage.removeItem(k)
      })
    } catch (e) {}
    setAccount(null)
    setEstAbonne(false)
    setNaclKeyPair(null)
  }

  // ─── THEME ───
  var [dark, setDark] = useState(function() {
    var s = localStorage.getItem('zonefree-dark')
    return s !== null ? JSON.parse(s) : true
  })

  // ─── WALLET / BLOCKCHAIN ───
  var [account, setAccount] = useState(null)
  var [estAbonne, setEstAbonne] = useState(false)
  var [loadingAbo, setLoadingAbo] = useState(false)
  var [expiration, setExpiration] = useState(null)
  var [prixETH, setPrixETH] = useState(null)
  var [totalAbonnes, setTotalAbonnes] = useState(null)
  var [maxGratuit, setMaxGratuit] = useState(300)
  var [udDomain, setUdDomain] = useState(null)

  // ─── NAVIGATION ───
  var [page, setPage] = useState('home')

  // ─── PROFIL ───
  var [pseudo, setPseudo] = useState(getPseudoFromStorage)
  var [editPseudo, setEditPseudo] = useState(false)
  var [newPseudo, setNewPseudo] = useState('')

  // ─── FORUMS ───
  var [forums, setForums] = useState(function() {
    var s = localStorage.getItem('zonefree-forums')
    return s ? JSON.parse(s) : FORUMS_INIT
  })
  var [activeForum, setActiveForum] = useState(null)
  var [activeTopic, setActiveTopic] = useState(null)
  var [showNewSalon, setShowNewSalon] = useState(false)
  var [showNewTopic, setShowNewTopic] = useState(false)
  var [newSalon, setNewSalon] = useState({ emoji: '', name: '', description: '' })
  var [newTopic, setNewTopic] = useState({ title: '', content: '' })
  var [newReply, setNewReply] = useState('')
  var [recherche, setRecherche] = useState('')
  var [rechercheTopic, setRechercheTopic] = useState('')
  var [sortBy, setSortBy] = useState('date')
  var [currentPage, setCurrentPage] = useState(1)

  // ─── LIKES ───
  var [likes, setLikes] = useState(function() {
    var s = localStorage.getItem('zonefree-likes')
    return s ? JSON.parse(s) : {}
  })

  // ─── MESSAGERIE LOCALE ───
  var [messages, setMessages] = useState(function() {
    var s = localStorage.getItem('zonefree-messages')
    return s ? JSON.parse(s) : []
  })
  var [activeConversation, setActiveConversation] = useState(null)
  var [newMessage, setNewMessage] = useState('')
  var [newMessageTo, setNewMessageTo] = useState('')
  var [showNewConversation, setShowNewConversation] = useState(false)

  // ─── FLASH CHAT ───
  var [flashPseudo, setFlashPseudo] = useState(function() {
    return localStorage.getItem('bp-flash-pseudo') || ''
  })
  var [flashEditPseudo, setFlashEditPseudo] = useState(false)
  var [flashMessages, setFlashMessages] = useState([])
  var [flashInput, setFlashInput] = useState('')

  // eslint-disable-next-line no-unused-vars
  var imageInputRef = useRef(null)
  var gunSubscribed = useRef({})
  var activeConvKeyRef = useRef(null)
  var gunListenersRef = useRef([])
  var convListenersRef = useRef({})

  function trackGunListener(ref) {
    if (ref && typeof ref.off === 'function') gunListenersRef.current.push(ref)
    return ref
  }

  function trackConvListener(key, ref) {
    if (!ref || typeof ref.off !== 'function') return ref
    if (!convListenersRef.current[key]) convListenersRef.current[key] = []
    convListenersRef.current[key].push(ref)
    return ref
  }

  function offListenerList(arr) {
    if (!arr) return
    for (var i = 0; i < arr.length; i++) {
      try { if (arr[i] && typeof arr[i].off === 'function') arr[i].off() } catch (e) {}
    }
  }

  function cleanupConvListeners(key) {
    if (!key) return
    offListenerList(convListenersRef.current[key])
    delete convListenersRef.current[key]
    delete gunSubscribed.current[key]
  }

  function cleanupGunListeners() {
    offListenerList(gunListenersRef.current)
    gunListenersRef.current = []
    var convMap = convListenersRef.current
    Object.keys(convMap).forEach(function(k) { offListenerList(convMap[k]) })
    convListenersRef.current = {}
    gunSubscribed.current = {}
  }

  // ─── NACL E2E ───
  var [naclKeyPair, setNaclKeyPair] = useState(null)
  var [naclLoading, setNaclLoading] = useState(false)
  var [pubKeysKnown, setPubKeysKnown] = useState({})
  var [convChiffrees, setConvChiffrees] = useState({})

  // ─── NOTIFICATIONS ───
  var [notifPermission, setNotifPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'denied'
  )
  var [membresListe, setMembresListe] = useState(function() {
    try { return JSON.parse(localStorage.getItem('freezone-membres') || '[]') } catch (e) { return [] }
  })

  // ═══════════════════ EFFECTS ═══════════════════
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(function() {
    if (isConnected && address && address !== account) {
      setAccount(address)
      var provider = new ethers.BrowserProvider(walletProvider)
      verifierAbonnement(address, provider)
    }
    if (!isConnected && !address && account) {
      setAccount(null)
      setEstAbonne(false)
    }
    // Fallback MetaMask direct si AppKit ne détecte pas
    if (!isConnected && window.ethereum) {
      window.ethereum.request({ method: 'eth_accounts' }).then(function(accounts) {
        if (accounts.length > 0 && !account) {
          setAccount(accounts[0])
          var provider = new ethers.BrowserProvider(window.ethereum)
          verifierAbonnement(accounts[0], provider)
        }
      }).catch(function() {})
    }
  }, [isConnected, address])

  useEffect(function() {
    try {
      Object.keys(localStorage).forEach(function(k) {
        if (k.indexOf('zonefree-nacl-sec-') === 0) localStorage.removeItem(k)
        if (k.indexOf('zonefree-nacl-') === 0
            && k.indexOf('zonefree-nacl-pub-') !== 0
            && k.indexOf('zonefree-nacl-sec-') !== 0
            && k.indexOf('zonefree-nacl-keys') !== 0) {
          localStorage.removeItem(k)
        }
      })
    } catch (e) {}
  }, [])

  useEffect(function() {
    if (!account) return
    if (naclKeyPair) return
    try {
      var addrKeySS = String(account).toLowerCase()
      var pubB64SS = localStorage.getItem('znf-nacl-pub-' + addrKeySS)
      var secB64SS = localStorage.getItem('znf-nacl-sec-' + addrKeySS)
      if (pubB64SS && secB64SS) {
        setNaclKeyPair({
          publicKey: naclUtil.decodeBase64(pubB64SS),
          secretKey: naclUtil.decodeBase64(secB64SS)
        })
        try { localStorage.setItem('zonefree-nacl-pub-' + addrKeySS, pubB64SS) } catch (e) {}
      }
    } catch (e) {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  useEffect(function() {
    if (!account) return
    try {
      setMessages(function(prev) {
        var accLow = String(account).toLowerCase()
        function isFullAddr(s) {
          return typeof s === 'string' && s.length === 42 && s.indexOf('0x') === 0
        }
        function normalizeConv(c) {
          if (!c || !c.participants) return c
          var newParts = []
          var changed = false
          for (var p = 0; p < c.participants.length; p++) {
            var part = c.participants[p]
            var partStr = String(part || '')
            if (isMe(part)) {
              if (partStr.toLowerCase() !== accLow) changed = true
              newParts.push(accLow)
            } else if (isFullAddr(partStr)) {
              if (partStr !== partStr.toLowerCase()) changed = true
              newParts.push(partStr.toLowerCase())
            } else {
              newParts.push(part)
            }
          }
          var canRebuild = newParts.length === 2 && isFullAddr(newParts[0]) && isFullAddr(newParts[1])
          if (changed || canRebuild) {
            var newKey = canRebuild ? getConvKey(newParts[0], newParts[1]) : String(c.key || '').toLowerCase()
            return Object.assign({}, c, { participants: newParts, key: newKey })
          }
          return Object.assign({}, c, { key: String(c.key || '').toLowerCase() })
        }
        function participantsKey(c) {
          if (!c || !c.participants || c.participants.length < 2) return ''
          return c.participants.slice().map(function(p) { return String(p).toLowerCase() }).sort().join('-')
        }
        function mergeInto(target, source) {
          var seenIds = {}
          for (var m = 0; m < target.msgs.length; m++) {
            if (target.msgs[m] && target.msgs[m].id != null) seenIds[String(target.msgs[m].id)] = true
          }
          var add = []
          var src = source.msgs || []
          for (var n = 0; n < src.length; n++) {
            var msg = src[n]
            if (!msg || msg.id == null) continue
            if (seenIds[String(msg.id)]) continue
            seenIds[String(msg.id)] = true
            add.push(msg)
          }
          return Object.assign({}, target, { msgs: target.msgs.concat(add) })
        }
        var byParts = {}
        for (var i = 0; i < prev.length; i++) {
          var c = normalizeConv(prev[i])
          if (!c) continue
          var pk = participantsKey(c)
          var canonKey = pk || String(c.key || '').toLowerCase()
          if (pk && c.key !== pk) {
            c = Object.assign({}, c, { key: pk })
          }
          if (!byParts[canonKey]) {
            byParts[canonKey] = Object.assign({}, c, { key: canonKey, msgs: (c.msgs || []).slice() })
          } else {
            byParts[canonKey] = mergeInto(byParts[canonKey], c)
          }
        }
        var out = []
        for (var kk in byParts) { if (Object.prototype.hasOwnProperty.call(byParts, kk)) out.push(byParts[kk]) }
        try { localStorage.setItem('zonefree-messages', JSON.stringify(out)) } catch (e) {}
        return out
      })
    } catch (e) { console.warn('merge dup convs error:', e) }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(function() {
    if (!account) return
    try {
      var moi = shortAddr(account)
      setMembresListe(function(prev) {
        var byAddr = {}
        for (var k = 0; k < prev.length; k++) {
          if (prev[k] && prev[k].address) byAddr[String(prev[k].address).toLowerCase()] = prev[k]
        }
        for (var i = 0; i < messages.length; i++) {
          var conv = messages[i]
          if (!conv || !conv.participants) continue
          var other = null
          for (var j = 0; j < conv.participants.length; j++) {
            if (conv.participants[j] !== moi) { other = conv.participants[j]; break }
          }
          if (!other) continue
          var key = String(other).toLowerCase()
          if (!byAddr[key]) {
            byAddr[key] = { address: key, pseudo: getPseudoOrAddr(other), lastSeen: 0, avatar: '' }
          }
        }
        var out = []
        for (var kk in byAddr) { if (Object.prototype.hasOwnProperty.call(byAddr, kk)) out.push(byAddr[kk]) }
        return out
      })
    } catch (e) {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, pseudo, messages])

  useEffect(function() {
    if (!account) return
    function publishPresence() {
      try {
        gun.get('zonefree-presence').get(String(account).toLowerCase()).put({
          address: String(account).toLowerCase(),
          pseudo: pseudo || '',
          lastSeen: Date.now()
        })
      } catch (e) { console.warn('publishPresence error:', e) }
    }
    publishPresence()
    var iv = setInterval(publishPresence, 30000)
    return function() { clearInterval(iv) }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, pseudo])

  useEffect(function() {
    try {
      var presenceRef = gun.get('zonefree-presence').map()
      trackGunListener(presenceRef)
      presenceRef.on(function(membre) {
        if (!membre || !membre.address) return
        var addrLower = String(membre.address).toLowerCase()
        setMembresListe(function(prev) {
          var existe = prev.some(function(m) {
            return m && m.address && String(m.address).toLowerCase() === addrLower
          })
          if (existe) {
            return prev.map(function(m) {
              return (m && m.address && String(m.address).toLowerCase() === addrLower)
                ? Object.assign({}, m, { address: addrLower, pseudo: membre.pseudo, lastSeen: membre.lastSeen })
                : m
            })
          }
          return prev.concat([{
            address: addrLower,
            pseudo: membre.pseudo || (addrLower.substring(0, 6) + '...'),
            lastSeen: membre.lastSeen || 0,
            avatar: ''
          }])
        })
      })
    } catch (e) { console.warn('Gun presence subscribe error:', e) }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  var topicSubscribed = useRef({})
  var replySubscribed = useRef({})

  function handleGunReply(rep, fid) {
    if (!rep || !rep.id) return
    if (rep.deleted === true) {
      var removeReply = function(topics) {
        return (topics || []).map(function(t) {
          var filtered = (t.replies || []).filter(function(r) { return String(r.id) !== String(rep.id) })
          if (filtered.length === (t.replies || []).length) return t
          return Object.assign({}, t, { replies: filtered })
        })
      }
      setForums(function(prev) {
        var next = prev.map(function(f) {
          if (String(f.id) !== String(fid)) return f
          return Object.assign({}, f, { topics: removeReply(f.topics) })
        })
        try { localStorage.setItem('zonefree-forums', JSON.stringify(next)) } catch (e) {}
        return next
      })
      setActiveForum(function(prev) {
        if (!prev || String(prev.id) !== String(fid)) return prev
        return Object.assign({}, prev, { topics: removeReply(prev.topics) })
      })
      setActiveTopic(function(prev) {
        if (!prev) return prev
        var filtered = (prev.replies || []).filter(function(r) { return String(r.id) !== String(rep.id) })
        if (filtered.length === (prev.replies || []).length) return prev
        return Object.assign({}, prev, { replies: filtered })
      })
      return
    }
    if (!rep.content || !rep.topicId) return
    function insertReply(topics) {
      return (topics || []).map(function(t) {
        if (String(t.id) !== String(rep.topicId)) return t
        var existe = (t.replies || []).some(function(r) { return String(r.id) === String(rep.id) })
        if (existe) return t
        return Object.assign({}, t, { replies: (t.replies || []).concat([rep]) })
      })
    }
    setForums(function(prev) {
      var changed = false
      var next = prev.map(function(f) {
        if (String(f.id) !== String(fid)) return f
        var newTopics = insertReply(f.topics)
        if (newTopics !== f.topics) { changed = true; return Object.assign({}, f, { topics: newTopics }) }
        return f
      })
      return changed ? next : prev
    })
    setActiveForum(function(prev) {
      if (!prev || String(prev.id) !== String(fid)) return prev
      var updatedTopics = insertReply(prev.topics)
      if (updatedTopics === prev.topics) return prev
      return Object.assign({}, prev, { topics: updatedTopics })
    })
    setActiveTopic(function(prev) {
      if (!prev || String(prev.id) !== String(rep.topicId)) return prev
      var existe = (prev.replies || []).some(function(r) { return String(r.id) === String(rep.id) })
      if (existe) return prev
      return Object.assign({}, prev, { replies: (prev.replies || []).concat([rep]) })
    })
  }

  function subscribeRepliesForTopic(fid, topicId) {
    var rkey = String(fid) + '-' + String(topicId)
    if (replySubscribed.current[rkey]) return
    replySubscribed.current[rkey] = true
    try {
      gun.get('zonefree-replies-' + rkey).map().once(function(rep) {
        if (rep) handleGunReply(rep, fid)
      })
      var repliesRef = gun.get('zonefree-replies-' + rkey).map()
      trackGunListener(repliesRef)
      repliesRef.on(function(rep) {
        if (rep) handleGunReply(rep, fid)
      })
    } catch (e) { console.warn('Gun replies subscribe error:', e) }
  }

  function handleGunTopic(topic, fid) {
    if (!topic || !topic.id) return
    if (topic.deleted === true) {
      setForums(function(prev) {
        var next = prev.map(function(f) {
          if (String(f.id) !== String(fid)) return f
          var filtered = (f.topics || []).filter(function(t) { return String(t.id) !== String(topic.id) })
          if (filtered.length === (f.topics || []).length) return f
          return Object.assign({}, f, { topics: filtered })
        })
        try { localStorage.setItem('zonefree-forums', JSON.stringify(next)) } catch (e) {}
        return next
      })
      setActiveForum(function(prev) {
        if (!prev || String(prev.id) !== String(fid)) return prev
        var filtered = (prev.topics || []).filter(function(t) { return String(t.id) !== String(topic.id) })
        if (filtered.length === (prev.topics || []).length) return prev
        return Object.assign({}, prev, { topics: filtered })
      })
      setActiveTopic(function(prev) {
        if (!prev || String(prev.id) !== String(topic.id)) return prev
        return null
      })
      return
    }
    if (!topic.title) return
    setForums(function(prev) {
      var changed = false
      var next = prev.map(function(f) {
        if (String(f.id) !== String(fid)) return f
        var topicFound = false
        var topicChanged = false
        var updatedTopics = (f.topics || []).map(function(t) {
          if (String(t.id) !== String(topic.id)) return t
          topicFound = true
          var newFields = {
            title: topic.title,
            content: topic.content || '',
            author: topic.author || '',
            date: topic.date || t.date
          }
          if (t.title === newFields.title && t.content === newFields.content &&
              t.author === newFields.author && t.date === newFields.date) {
            return t
          }
          topicChanged = true
          return Object.assign({}, t, newFields)
        })
        if (!topicFound) {
          changed = true
          var newTopic = Object.assign({}, {
            id: topic.id,
            title: topic.title,
            content: topic.content || '',
            author: topic.author || '',
            pinned: false,
            replies: [],
            date: topic.date || new Date().toLocaleDateString('fr-FR')
          })
          return Object.assign({}, f, { topics: [newTopic].concat(f.topics || []) })
        }
        if (topicChanged) {
          changed = true
          return Object.assign({}, f, { topics: updatedTopics })
        }
        return f
      })
      return changed ? next : prev
    })
    subscribeRepliesForTopic(fid, topic.id)
  }

  function subscribeTopicsForForum(forumId) {
    var fid = String(forumId)
    if (topicSubscribed.current[fid]) return
    topicSubscribed.current[fid] = true
    try {
      gun.get('zonefree-topics-' + fid).map().once(function(topic) {
        if (topic) handleGunTopic(topic, fid)
      })
      var topicsRef = gun.get('zonefree-topics-' + fid).map()
      trackGunListener(topicsRef)
      topicsRef.on(function(topic) {
        if (topic) handleGunTopic(topic, fid)
      })
    } catch (e) { console.warn('Gun topics subscribe error:', e) }
  }

  useEffect(function() {
    try {
      var forumsActuels = JSON.parse(localStorage.getItem('zonefree-forums') || '[]')
      var forumsPropres = forumsActuels.filter(function(f) {
        var nom = String(f.name || f.nom || '').trim()
        if (nom.length < 3) return false
        if (/^\d+$/.test(nom)) return false
        if (/^[A-Za-z]{1,2}$/.test(nom)) return false
        return true
      })
      if (forumsPropres.length !== forumsActuels.length) {
        localStorage.setItem('zonefree-forums', JSON.stringify(forumsPropres))
        setForums(forumsPropres)
      }
    } catch (e) {}

    function handleSalonData(salonData) {
      if (!salonData || typeof salonData !== 'object') return
      if (typeof salonData === 'object' && salonData['#'] && !salonData.id) {
        gun.get(salonData['#']).once(function(realData) {
          if (!realData) return
          handleSalonData(realData)
        })
        return
      }
      if (!salonData.id || !salonData.name) return
      if (String(salonData.name).trim().length < 3) return
      try {
        var suppressions = JSON.parse(localStorage.getItem('zonefree-suppressed') || '[]')
        if (suppressions.indexOf(String(salonData.id)) !== -1) return
      } catch (e) {}
      if (salonData.deleted) {
        var delId = String(salonData.id)
        setForums(function(prev) {
          return prev.filter(function(f) { return String(f.id) !== delId })
        })
        return
      }
      var copy = Object.assign({}, salonData, { topics: [] })
      setForums(function(prev) {
        var existe = false
        var changed = false
        var next = prev.map(function(f) {
          if (String(f.id) !== String(copy.id)) return f
          existe = true
          var keys = Object.keys(copy)
          var diff = false
          for (var k = 0; k < keys.length; k++) {
            var key = keys[k]
            if (key === 'topics') continue
            if (f[key] !== copy[key]) { diff = true; break }
          }
          if (!diff) return f
          changed = true
          return Object.assign({}, f, copy, { topics: f.topics || [] })
        })
        if (!existe) return prev.concat([copy])
        return changed ? next : prev
      })
    }

    gun.get('zonefree-registry').map().once(function(salonData, key) {
      if (!key || key === '_') return
      handleSalonData(salonData)
    })

    var registryRef = gun.get('zonefree-registry').map()
    trackGunListener(registryRef)
    registryRef.on(function(salonData, key) {
      if (!key || key === '_') return
      handleSalonData(salonData)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(function() {
    forums.forEach(function(f) {
      if (f && f.id) subscribeTopicsForForum(f.id)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forums])

  useEffect(function() {
    try {
      var reactionsRef = gun.get('zonefree-reactions').map()
      trackGunListener(reactionsRef)
      reactionsRef.on(function(reaction) {
        if (!reaction || !reaction.id) return
        var rid = String(reaction.id)
        if (typeof reaction.likes === 'number') {
          setLikes(function(prev) {
            var cur = prev[rid] || { count: 0, likedBy: [] }
            if (cur.count === reaction.likes) return prev
            var next = Object.assign({}, prev)
            next[rid] = Object.assign({}, cur, { count: reaction.likes })
            return next
          })
        }
        if (typeof reaction.pinned === 'boolean' && reaction.topicId != null) {
          setForums(function(prev) {
            var changed = false
            var next = prev.map(function(f) {
              if (!f.topics) return f
              var touched = false
              var newTopics = f.topics.map(function(t) {
                if (String(t.id) !== String(reaction.topicId)) return t
                if (t.pinned === reaction.pinned) return t
                touched = true
                return Object.assign({}, t, { pinned: reaction.pinned })
              })
              if (touched) { changed = true; return Object.assign({}, f, { topics: newTopics }) }
              return f
            })
            return changed ? next : prev
          })
        }
      })
    } catch (e) { console.warn('Gun reactions subscribe error:', e) }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(function() {
    try {
      var naclKeysRef = gun.get('zonefree-nacl-keys').map()
      trackGunListener(naclKeysRef)
      naclKeysRef.on(function(data, key) {
        if (!data || !data.pubKey) return
        var addr = String(data.address || key || '').toLowerCase()
        if (!addr || addr === '_') return
        try { localStorage.setItem('zonefree-nacl-pub-' + addr, data.pubKey) } catch (e) {}
        setPubKeysKnown(function(prev) {
          if (prev[addr]) return prev
          var next = Object.assign({}, prev)
          next[addr] = true
          return next
        })
      })
    } catch (e) { console.warn('Gun nacl-keys subscribe error:', e) }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(function() {
    var next = {}
    for (var i = 0; i < messages.length; i++) {
      var conv = messages[i]
      if (!conv) continue
      var hasEncMsg = (conv.msgs || []).some(function(m) {
        return m && (m.encrypted === true
          || (typeof m.content === 'string' && m.content.indexOf('{"enc":') === 0))
      })
      var other = null
      if (conv.participants) {
        for (var p = 0; p < conv.participants.length; p++) {
          if (!isMe(conv.participants[p])) { other = conv.participants[p]; break }
        }
      }
      var otherAddr = String(other || '').toLowerCase()
      var hasPubKey = false
      if (otherAddr) {
        if (pubKeysKnown[otherAddr]) hasPubKey = true
        else {
          try { hasPubKey = !!localStorage.getItem('zonefree-nacl-pub-' + otherAddr) } catch (e) {}
        }
      }
      next[conv.id] = hasEncMsg || hasPubKey
    }
    setConvChiffrees(next)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, pubKeysKnown, account])

  useEffect(function() {
    if (!activeConversation || !activeConversation.key) return
    var k = activeConversation.key
    setMessages(function(prev) {
      var changed = false
      var next = prev.map(function(c) {
        if (c.key !== k) return c
        var touched = false
        var newMsgs = (c.msgs || []).map(function(m) {
          if (m && !m.read && isMe(m.to)) {
            touched = true
            return Object.assign({}, m, { read: true })
          }
          return m
        })
        if (touched) { changed = true; return Object.assign({}, c, { msgs: newMsgs }) }
        return c
      })
      return changed ? next : prev
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeConversation])

  useEffect(function() { localStorage.setItem('zonefree-forums', JSON.stringify(forums)) }, [forums])
  useEffect(function() {
    localStorage.setItem('zonefree-dark', JSON.stringify(dark))
    document.body.className = dark ? 'dark' : 'light'
    document.documentElement.className = dark ? 'dark' : 'light'
  }, [dark])
  useEffect(function() { localStorage.setItem('zonefree-likes', JSON.stringify(likes)) }, [likes])
  useEffect(function() {
    try {
      var msgsSansImages = messages.map(function(conv) {
        var msgs2 = conv.msgs.map(function(m) {
          if (m.type === 'image') {
            return Object.assign({}, m, { content: '[image]' })
          }
          return m
        })
        return Object.assign({}, conv, { msgs: msgs2 })
      })
      localStorage.setItem('zonefree-messages', JSON.stringify(msgsSansImages))
    } catch (e) {
      console.warn('localStorage plein', e)
    }
  }, [messages])
  useEffect(function() {
    Object.keys(localStorage).forEach(function(k) {
      if (k.indexOf('zonefree-conv-cid-') === 0) {
        localStorage.removeItem(k)
      }
    })
  }, [])

  useEffect(function() {
    try {
      var flashRef = gun.get('blabla-flash').map()
      trackGunListener(flashRef)
      flashRef.on(function(data, key) {
        if (!data || !key || key === '_') return
        if (!data.id || !data.content) return
        var ts = Number(data.timestamp || 0)
        if (ts && (Date.now() - ts) > 3600000) return
        setFlashMessages(function(prev) {
          for (var i = 0; i < prev.length; i++) {
            if (String(prev[i].id) === String(data.id)) return prev
          }
          var next = prev.concat([{
            id: data.id,
            pseudo: data.pseudo || 'anon',
            content: data.content,
            timestamp: ts
          }])
          next.sort(function(a, b) { return a.timestamp - b.timestamp })
          return next
        })
      })
    } catch (e) { console.warn('Gun flash subscribe error:', e) }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(function() {
    try { localStorage.setItem('bp-flash-pseudo', flashPseudo) } catch (e) {}
  }, [flashPseudo])

  useEffect(function() {
    var iv = setInterval(function() {
      setFlashMessages(function(prev) {
        var now = Date.now()
        var next = prev.filter(function(m) { return (now - m.timestamp) < 3600000 })
        return next.length === prev.length ? prev : next
      })
    }, 60000)
    return function() { clearInterval(iv) }
  }, [])

  useEffect(function() {
    return function() { cleanupGunListeners() }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  var prevConvKeyRef = useRef(null)
  useEffect(function() {
    var current = activeConversation && activeConversation.key ? activeConversation.key : null
    var prev = prevConvKeyRef.current
    if (prev && prev !== current) {
      cleanupConvListeners(prev)
    }
    prevConvKeyRef.current = current
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeConversation])

  useEffect(function() {
    localStorage.setItem('zonefree-pseudo', pseudo)
  }, [pseudo])


  // ═══════════════════ NOTIFICATIONS ═══════════════════
  var demanderNotifications = async function() {
    if (typeof Notification === 'undefined') {
      alert('Votre navigateur ne supporte pas les notifications.')
      return
    }
    try {
      var p = await Notification.requestPermission()
      setNotifPermission(p)
      if (p === 'granted') {
        new Notification('🔔 Blabla.Privacy', { body: 'Notifications activées avec succès !', icon: '/favicon.ico' })
      } else {
        alert('Notifications refusées. Autorisez-les dans les paramètres du navigateur.')
      }
    } catch (e) {
      alert('Erreur notifications : ' + e.message)
    }
  }

  var envoyerNotif = function(titre, corps) {
    if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
      try { new Notification(titre, { body: corps, icon: '/favicon.ico' }) } catch (e) {}
    }
  }

  // ═══════════════════ UNSTOPPABLE DOMAINS ═══════════════════
  var resoudreUD = async function(address) {
    if (!address) return null
    var endpoints = [
      `https://resolve.unstoppabledomains.com/reverse/${address.toLowerCase()}`,
      `https://api.unstoppabledomains.com/resolve/reverse/${address.toLowerCase()}`
    ]
    for (var url of endpoints) {
      try {
        var r = await fetch(url, { headers: { 'Accept': 'application/json' } })
        if (r.ok) {
          var d = await r.json()
          var domain = d?.meta?.domain || d?.data?.domain || null
          if (domain) return domain
        }
      } catch (e) {}
    }
    return null
  }

  var detecterUD = async function() {
    var addr = account || address
    if (!addr) { alert('Connectez votre wallet d\'abord !'); return }
    var domain = await resoudreUD(addr)
    if (domain) {
      setUdDomain(domain)
      alert(`✅ Domaine trouvé : ${domain}`)
    } else {
      alert(`Aucun domaine .x trouvé pour ce wallet.\n\nCela peut être normal si le domaine est récent ou si l'API UD est indisponible temporairement.`)
    }
  }

  // ═══════════════════ LIKES ═══════════════════
  var toggleLike = function(key) {
    if (!account) { alert('Connectez MetaMask pour liker !'); return }
    if (!estAbonne) { alert('Abonnement requis pour liker !'); return }
    var cur = likes[key] || { count: 0, likedBy: [] }
    var has = cur.likedBy.includes(account)
    var newCount = has ? cur.count - 1 : cur.count + 1
    var nextLikes = Object.assign({}, likes)
    nextLikes[key] = {
      count: newCount,
      likedBy: has ? cur.likedBy.filter(function(a) { return a !== account }) : cur.likedBy.concat([account])
    }
    setLikes(nextLikes)
    try {
      gun.get('zonefree-reactions').get(String(key)).put({
        id: String(key),
        likes: newCount,
        pinned: false,
        forumId: activeForum ? activeForum.id : ''
      })
    } catch (e) { console.warn('publish reaction Gun error:', e) }
  }
  var getLike = function(key) {
    var l = likes[key] || { count: 0, likedBy: [] }
    return { count: l.count, hasLiked: l.likedBy.includes(account) }
  }

  // ═══════════════════ TRI ═══════════════════
  var sortTopics = function(topics, forumId) {
    var s = (topics || []).slice()
    if (sortBy === 'popular') return s.sort(function(a, b) {
      var la = likes[forumId + '-' + b.id]
      var lb = likes[forumId + '-' + a.id]
      return ((la && la.count) || 0) - ((lb && lb.count) || 0)
    })
    if (sortBy === 'replies') return s.sort(function(a, b) { return b.replies.length - a.replies.length })
    return s.sort(function(a, b) {
      if (a.pinned && !b.pinned) return -1
      if (!a.pinned && b.pinned) return 1
      return b.id - a.id
    })
  }

  // ═══════════════════ MESSAGERIE LOCALE ═══════════════════
  function getConvKey(a, b) {
    var aLow = String(a || '').toLowerCase()
    var bLow = String(b || '').toLowerCase()
    return [aLow, bLow].sort().join('-')
  }

  function hashConvKey(key) {
    var k = String(key || '')
    var hash = 0
    for (var i = 0; i < k.length; i++) {
      var c = k.charCodeAt(i)
      hash = ((hash << 5) - hash) + c
      hash = hash & hash
    }
    var h = Math.abs(hash).toString(36)
    var short = k.replace('0x', '').replace(/-/g, '').substring(0, 8) + h + k.slice(-8).replace('0x', '')
    return 'zf-' + short
  }

  function isMe(p) {
    if (!p || !account) return false
    var pLow = String(p).toLowerCase()
    var accLow = String(account).toLowerCase()
    if (pLow === accLow) return true
    var sa = shortAddr(account)
    if (p === sa) return true
    if (pLow === String(sa).toLowerCase()) return true
    return false
  }

  var demarrerConversation = function() {
    if (!newMessageTo.trim()) { alert('Entrez une adresse !'); return }
    var addrLow = String(newMessageTo.trim()).toLowerCase()
    var accLow = String(account).toLowerCase()
    var key = getConvKey(accLow, addrLow)
    var existing = messages.find(function(m) { return m.key === key })
    if (existing) { setActiveConversation(existing) }
    else {
      var nc = { id: Date.now(), key: key, participants: [accLow, addrLow], msgs: [] }
      setMessages(function(prev) { return prev.concat([nc]) })
      setActiveConversation(nc)
    }
    setShowNewConversation(false); setNewMessageTo(''); setPage('conversation')
  }

  function envoyerMessage() {
    if (!account || !estAbonne || !newMessage.trim() || !activeConversation) return
    var myAddr = String(account).toLowerCase()
    try {
      var contenu = newMessage
      var otherAddress = activeConversation.participants.find(function(p) { return !isMe(p) })
      var otherAddr = String(otherAddress || '').toLowerCase()
      // Toujours re-fetcher la clé pub du destinataire depuis Gun
      if (otherAddr) {
        try {
          gun.get('zonefree-nacl-keys').get(otherAddr).once(function(data) {
            if (data && data.pubKey) {
              localStorage.setItem('zonefree-nacl-pub-' + otherAddr, data.pubKey)
            }
          })
        } catch (e) { console.warn('lookup nacl pub error:', e) }
      }
      var otherPubB64 = localStorage.getItem('zonefree-nacl-pub-' + otherAddr)
      var mySecKey = naclKeyPair ? naclKeyPair.secretKey : null
      var content = contenu
      var encrypted = false
      if (otherPubB64 && mySecKey) {
        try {
          var recipientPub = new Uint8Array(atob(otherPubB64).split('').map(function(c) { return c.charCodeAt(0) }))
          var msgBytes = new TextEncoder().encode(contenu)
          var nonce = nacl.randomBytes(nacl.box.nonceLength)
          var box = nacl.box(msgBytes, nonce, recipientPub, mySecKey)
          content = JSON.stringify({
            enc: btoa(String.fromCharCode.apply(null, box)),
            nonce: btoa(String.fromCharCode.apply(null, nonce)),
            v: 'box1'
          })
          encrypted = true
        } catch (e) {
          console.warn('chiffrement échoué, envoi en clair', e)
        }
      }
      var msg = {
        id: Date.now(),
        from: shortAddr(account),
        fromAddr: myAddr,
        to: otherAddress,
        toAddr: otherAddr,
        content: content,
        type: 'text',
        encrypted: encrypted,
        date: new Date().toLocaleDateString('fr-FR'),
        timestamp: Date.now(),
        read: false
      }
      var newMsgs = activeConversation.msgs.concat([msg])
      var updatedConv = Object.assign({}, activeConversation, { msgs: newMsgs })
      setActiveConversation(updatedConv)
      setMessages(function(prev) {
        return prev.map(function(c) {
          return c.key === activeConversation.key ? updatedConv : c
        })
      })
      setNewMessage('')
      transporterMessage(activeConversation, msg)
    } catch (err) { console.error('envoyerMessage crash:', err) }
  }

  // eslint-disable-next-line no-unused-vars
  var envoyerImage = function(e) {
    try {
      var file = e.target.files[0]
      if (!file || !account || !estAbonne || !activeConversation) return
      var reader = new FileReader()
      reader.onload = function(ev) {
        try {
          var otherImg = activeConversation.participants.find(function(p) { return !isMe(p) })
          var msg = {
            id: Date.now(),
            from: shortAddr(account),
            fromAddr: String(account || '').toLowerCase(),
            to: otherImg,
            toAddr: String(otherImg || '').toLowerCase(),
            content: ev.target.result, type: 'image',
            date: new Date().toLocaleDateString('fr-FR'),
            timestamp: Date.now(), read: false
          }
          var updated = Object.assign({}, activeConversation, { msgs: activeConversation.msgs.concat([msg]) })
          setMessages(function(prev) { return prev.map(function(c) { return c.key === activeConversation.key ? updated : c }) })
          setActiveConversation(updated)
          transporterMessage(activeConversation, msg)
        } catch (err) {
          console.error('envoyerImage onload crash:', err)
          alert('Erreur envoi image: ' + err.message)
        }
      }
      reader.readAsDataURL(file)
    } catch (err) {
      console.error('envoyerImage crash:', err)
      alert('Erreur envoi image: ' + err.message)
    }
  }

  function ouvrirConversation(conv) {
    activeConvKeyRef.current = conv ? conv.key : null
    setActiveConversation(conv)
    setPage('conversation')
    setMessages(function(prev) {
      return prev.map(function(c) {
        if (!conv || c.key !== conv.key) return c
        var changed = false
        var newMsgs = (c.msgs || []).map(function(m) {
          if (m && !m.read && isMe(m.to)) {
            changed = true
            return Object.assign({}, m, { read: true })
          }
          return m
        })
        return changed ? Object.assign({}, c, { msgs: newMsgs }) : c
      })
    })
    setActiveConversation(function(prev) {
      if (!prev || !conv || prev.key !== conv.key) return prev
      var changed = false
      var newMsgs = (prev.msgs || []).map(function(m) {
        if (m && !m.read && isMe(m.to)) {
          changed = true
          return Object.assign({}, m, { read: true })
        }
        return m
      })
      return changed ? Object.assign({}, prev, { msgs: newMsgs }) : prev
    })
    if (!conv || !conv.key) return
    function onGunMsg(msg) {
      if (!msg || !msg.id) return
      if (!msg.content && msg.content !== '') return
      var msgId = String(msg.id)
      var convOuverte = activeConvKeyRef.current === conv.key
      var incoming = Object.assign({}, msg, convOuverte ? { read: true } : {})
      setMessages(function(prev) {
        return prev.map(function(c) {
          if (c.key !== conv.key) return c
          var existe = c.msgs && c.msgs.some(function(m) { return String(m.id) === msgId })
          if (existe) return c
          var newMsgs = (c.msgs || []).concat([incoming])
          newMsgs.sort(function(a, b) { return (a.timestamp || 0) - (b.timestamp || 0) })
          return Object.assign({}, c, { msgs: newMsgs })
        })
      })
      setActiveConversation(function(prev) {
        if (!prev || prev.key !== conv.key) return prev
        var existe = prev.msgs && prev.msgs.some(function(m) { return String(m.id) === msgId })
        if (existe) return prev
        var newMsgs = (prev.msgs || []).concat([incoming])
        newMsgs.sort(function(a, b) { return (a.timestamp || 0) - (b.timestamp || 0) })
        return Object.assign({}, prev, { msgs: newMsgs })
      })
    }
    if (!gunSubscribed.current[conv.key]) {
      gunSubscribed.current[conv.key] = true
      try {
        var convMsgsRef = gun.get(hashConvKey(conv.key)).map()
        trackConvListener(conv.key, convMsgsRef)
        convMsgsRef.on(onGunMsg)
      } catch (e) { console.warn('Gun subscribe error:', e) }
    }
    if (conv.participants && conv.participants.length === 2) {
      var keyInverse = conv.participants.slice().reverse().join('-').toLowerCase()
      if (keyInverse !== conv.key && !gunSubscribed.current[keyInverse]) {
        gunSubscribed.current[keyInverse] = true
        try {
          var convMsgsInvRef = gun.get(hashConvKey(keyInverse)).map()
          trackConvListener(conv.key, convMsgsInvRef)
          convMsgsInvRef.on(onGunMsg)
        } catch (e) { console.warn('Gun subscribe inverse error:', e) }
      }
    }
  }

  var unreadCount = account
    ? Math.min(9, messages.reduce(function(t, c) { return t + c.msgs.filter(function(m) { return isMe(m.to) && !m.read }).length }, 0))
    : 0

   // ═══════════════════ NACL E2E ═══════════════════
  var initNaclKeys = async function() {
    if (!account) { alert('Connectez votre wallet d\'abord !'); return }
    var provider = walletProvider || window.ethereum
    if (!provider) { alert('Provider wallet introuvable.'); return }
    setNaclLoading(true)
    try {
      var message = 'ZoneFree E2E Key v1'
      var messageBytes = new TextEncoder().encode(message)
      var messageHex = '0x' + Array.from(messageBytes)
        .map(function(b) { return b.toString(16).padStart(2, '0') }).join('')
      var sig = await provider.request({
        method: 'personal_sign',
        params: [messageHex, address || account]
      })
      var sigHex = sig.startsWith('0x') ? sig.slice(2) : sig
      var sigBytes = new Uint8Array(sigHex.match(/.{1,2}/g).map(function(b) { return parseInt(b, 16) }))
      var seed = nacl.hash(sigBytes).slice(0, 32)
      var kp = nacl.box.keyPair.fromSecretKey(seed)
      setNaclKeyPair(kp)
      var pubB64 = naclUtil.encodeBase64(kp.publicKey)
      var secB64 = naclUtil.encodeBase64(kp.secretKey)
      var addrKey = String(account).toLowerCase()
      localStorage.setItem('zonefree-nacl-pub-' + addrKey, pubB64)
      try {
        localStorage.setItem('znf-nacl-pub-' + addrKey, pubB64)
        localStorage.setItem('znf-nacl-sec-' + addrKey, secB64)
      } catch (e) {}
      try {
        gun.get('zonefree-nacl-keys').get(addrKey).put({
          address: addrKey,
          pubKey: pubB64
        })
        var naclInitRef = gun.get('zonefree-nacl-keys').get(addrKey)
        trackGunListener(naclInitRef)
        naclInitRef.on(function(data) {
          if (data && data.pubKey) {
            localStorage.setItem('zonefree-nacl-pub-' + addrKey, data.pubKey)
          }
        })
      } catch (e) { console.warn('publish nacl pub error:', e) }
      envoyerNotif('🔐 NaCl E2E actif', 'Chiffrement Curve25519 activé !')
    } catch (e) {
      console.error('NaCl init error:', e)
      alert('Signature refusée. Le chiffrement E2E ne sera pas activé.')
    } finally {
      setNaclLoading(false)
    }
  }

  // eslint-disable-next-line no-unused-vars
  var naclEncrypt = function(text) {
    if (!naclKeyPair) return String(text)
    try {
      var nonce = nacl.randomBytes(24)
      var msgBytes = naclUtil.decodeUTF8(String(text))
      var encrypted = nacl.secretbox(msgBytes, nonce, naclKeyPair.secretKey)
      var result = JSON.stringify({
        e: naclUtil.encodeBase64(encrypted),
        n: naclUtil.encodeBase64(nonce)
      })
      return typeof result === 'string' ? result : String(result)
    } catch (err) {
      console.error('naclEncrypt error:', err)
      return typeof text === 'string' ? text : String(text)
    }
  }

  // eslint-disable-next-line no-unused-vars
  var naclDecrypt = function(data) {
    if (!data) return '...'
    if (typeof data !== 'string') return String(data)
    if (!naclKeyPair) return data
    try {
      var parsed = JSON.parse(data)
      if (!parsed.e || !parsed.n) return data
      var decrypted = nacl.secretbox.open(
        naclUtil.decodeBase64(parsed.e),
        naclUtil.decodeBase64(parsed.n),
        naclKeyPair.secretKey
      )
      if (!decrypted) return '[message chiffre]'
      return naclUtil.encodeUTF8(decrypted)
    } catch (e) {
      return data
    }
  }

  // ═══════════════════ BLOCKCHAIN ═══════════════════
  var fetchPrix = async function(provider) {
    try {
      var contract = new ethers.Contract(CONTRACT_ADDRESS, ForumAboABI, provider)
      var prix = await contract.getPrixEnWei()
      setPrixETH(prix)
      try { var nb = await contract.totalAbonnes(); setTotalAbonnes(Number(nb)) } catch (e) {}
      try { var max = await contract.GRATUITS(); setMaxGratuit(Number(max)) } catch (e) {}
      return prix
    } catch (e) { console.error('Prix:', e); return null }
  }

  var verifierAbonnement = async function(addr, prov) {
    try {
      var provider = prov || new ethers.BrowserProvider(walletProvider || window.ethereum)
      var contract = new ethers.Contract(CONTRACT_ADDRESS, ForumAboABI, provider)
      var abonne = await contract.estAbonne(addr)
      setEstAbonne(abonne)
      var exp = await contract.abonnements(addr)
      if (Number(exp) > 0) setExpiration(new Date(Number(exp) * 1000))
      await fetchPrix(provider)
      var domain = await resoudreUD(addr)
      if (domain) setUdDomain(domain)
    } catch (e) { console.error('Abonnement:', e) }
  }

  var estGratuit = totalAbonnes !== null && totalAbonnes < maxGratuit

  var sAbonner = async function() {
    if (!account) { alert('Connectez votre wallet !'); return }
    try {
      setLoadingAbo(true)
      var provider = new ethers.BrowserProvider(walletProvider || window.ethereum)
      var signer = await provider.getSigner()
      var contract = new ethers.Contract(CONTRACT_ADDRESS, ForumAboABI, signer)
      var prixWei = estGratuit ? 0n : await contract.getPrixEnWei()
      var tx = await contract.sAbonner({ value: prixWei })
      await tx.wait()
      setEstAbonne(true)
      await verifierAbonnement(account)
      envoyerNotif('🎉 Blabla.Privacy', 'Abonnement activé pour 30 jours !')
      alert(estGratuit
        ? '🎁 Abonnement GRATUIT activé ! Bienvenue Early Adopter !'
        : '✅ Abonnement activé pour 30 jours !')
    } catch (e) { alert('Erreur : ' + e.message) }
    finally { setLoadingAbo(false) }
  }

  // ═══════════════════ NAVIGATION ═══════════════════
  var openForum = function(f) { setActiveForum(f); setRechercheTopic(''); setCurrentPage(1); setSortBy('date'); setPage('forum'); subscribeTopicsForForum(f.id) }
  var openTopic = function(t) { setActiveTopic(t); setPage('topic') }
  var goHome = function() { setPage('home'); setActiveForum(null); setActiveTopic(null); setRecherche('') }
  var goForum = function() { setPage('forum'); setActiveTopic(null) }
  function shortAddr(addr) { return addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : '' }
  function displayName(addr) { return pseudo || udDomain || shortAddr(addr) }
  function getPseudoOrAddr(address) {
    if (!address) return ''
    try {
      var membres = JSON.parse(localStorage.getItem('freezone-membres') || '[]')
      var lower = String(address).toLowerCase()
      var found = membres.find(function(m) {
        if (!m || !m.address) return false
        var a = String(m.address).toLowerCase()
        return a === lower || a === lower.replace(/\.\.\..*/, '') || lower.indexOf(a.slice(0, 6)) === 0
      })
      if (found && found.pseudo && String(found.pseudo).trim()) return found.pseudo
    } catch (e) {}
    return shortAddr(address)
  }
  function demarrerConversationAvec(addr) {
    if (!addr) return
    var addrLow = String(addr).toLowerCase()
    var accLow = String(account).toLowerCase()
    var key = getConvKey(accLow, addrLow)
    var existing = messages.find(function(m) { return m.key === key })
    var conv = existing
    if (!conv) {
      conv = { id: Date.now(), key: key, participants: [accLow, addrLow], msgs: [] }
      setMessages(function(prev) { return prev.concat([conv]) })
    }
    ouvrirConversation(conv)
  }
  var prixEnETH = prixETH ? parseFloat(ethers.formatEther(prixETH)).toFixed(6) : '...'

  // ═══════════════════ FORUM ACTIONS ═══════════════════
  var creerSalon = function() {
    if (!account) { alert('Connectez MetaMask !'); return }
    if (!estAbonne) { alert('Abonnement requis !'); return }
    var nomValide = String(newSalon.name || '').trim()
    if (nomValide.length < 3) {
      alert('Le nom du salon doit faire au moins 3 caractères')
      return
    }
    var salonId = String(Date.now())
    var salonData = {
      id: salonId,
      name: nomValide,
      description: newSalon.description || 'Nouveau salon',
      emoji: newSalon.emoji || '💬',
      creator: String(account).toLowerCase(),
      timestamp: Date.now(),
      deleted: false
    }
    setForums(function(prev) {
      return prev.concat([Object.assign({}, salonData, { topics: [] })])
    })
    setShowNewSalon(false)
    setNewSalon({ emoji: '', name: '', description: '' })
    try {
      gun.get('zonefree-registry').get(salonId).put(salonData, function(ack) {
        console.log('[GUN REGISTRY]', ack && ack.err ? 'ERREUR: ' + ack.err : 'OK id=' + salonId)
      })
    } catch (e) { console.warn('publish salon Gun error:', e) }
  }

  var creerTopic = async function() {
    if (!account) { alert('Connectez MetaMask !'); return }
    if (!estAbonne) { alert('Abonnement requis !'); return }
    if (!newTopic.title.trim()) { alert('Donnez un titre !'); return }
    var topicId = Date.now()
    var topic = {
      id: topicId, title: newTopic.title, content: newTopic.content,
      author: displayName(account), pinned: false, replies: [],
      date: new Date().toLocaleDateString('fr-FR'),
      timestamp: topicId, forumId: activeForum.id
    }
    var upd = forums.map(function(f) {
      if (f.id !== activeForum.id) return f
      return Object.assign({}, f, { topics: [topic].concat(f.topics) })
    })
    setForums(upd); setActiveForum(upd.find(function(f) { return f.id === activeForum.id }))
    setShowNewTopic(false); setNewTopic({ title: '', content: '' })
    try {
      gun.get('zonefree-topics-' + String(activeForum.id)).get(String(topic.id)).put({
        id: topic.id,
        title: topic.title,
        author: topic.author,
        content: topic.content || '',
        timestamp: topic.timestamp,
        forumId: String(activeForum.id),
        deleted: false
      })
    } catch (e) { console.warn('publish topic Gun error:', e) }
  }

  var sendFlashMessage = function() {
    if (!flashInput.trim()) return
    if (!flashPseudo.trim()) { alert('Enter a nickname'); return }
    var id = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 11)
    try {
      gun.get('blabla-flash').get(id).put({
        id: id,
        pseudo: flashPseudo,
        content: flashInput,
        timestamp: Date.now()
      })
    } catch (e) { console.warn('publish flash Gun error:', e) }
    setFlashInput('')
  }

  var posterReponse = async function() {
    if (!account) { alert('Connectez MetaMask !'); return }
    if (!estAbonne) { alert('Abonnement requis !'); return }
    if (!newReply.trim()) { alert('Écrivez un message !'); return }
    var replyId = Date.now()
    var reply = { id: replyId, author: displayName(account), content: newReply, date: new Date().toLocaleDateString('fr-FR') }
    var updTopic = Object.assign({}, activeTopic, { replies: activeTopic.replies.concat([reply]) })
    var upd = forums.map(function(f) {
      if (f.id !== activeForum.id) return f
      return Object.assign({}, f, {
        topics: f.topics.map(function(t) { return t.id === activeTopic.id ? updTopic : t })
      })
    })
    setForums(upd); setActiveForum(upd.find(function(f) { return f.id === activeForum.id }))
    setActiveTopic(updTopic); setNewReply('')
    envoyerNotif('💬 Nouvelle réponse', 'Dans : ' + activeTopic.title)
    try {
      var reponseKey = String(activeForum.id) + '-' + String(activeTopic.id)
      gun.get('zonefree-replies-' + reponseKey).get(String(replyId)).put({
        id: replyId,
        topicId: activeTopic.id,
        forumId: String(activeForum.id),
        content: newReply,
        author: displayName(account),
        authorFull: String(account).toLowerCase(),
        timestamp: replyId,
        date: new Date().toLocaleDateString('fr-FR')
      })
    } catch (e) { console.warn('publish reply Gun error:', e) }
  }

  var togglePin = function(topicId) {
    if (!estAbonne) return
    var newPinned = false
    var upd = forums.map(function(f) {
      if (f.id !== activeForum.id) return f
      return Object.assign({}, f, {
        topics: f.topics.map(function(t) {
          if (t.id !== topicId) return t
          newPinned = !t.pinned
          return Object.assign({}, t, { pinned: newPinned })
        })
      })
    })
    setForums(upd); setActiveForum(upd.find(function(f) { return f.id === activeForum.id }))
    try {
      var reactionKey = activeForum.id + '-' + topicId
      gun.get('zonefree-reactions').get(String(reactionKey)).put({
        id: String(reactionKey),
        topicId: topicId,
        likes: (likes[reactionKey] && likes[reactionKey].count) || 0,
        pinned: newPinned,
        forumId: activeForum.id
      })
    } catch (e) { console.warn('publish pin Gun error:', e) }
  }

  var supprimerSalon = function(forumId) {
    setForums(function(prev) {
      var nouveaux = prev.filter(function(f) { return String(f.id) !== String(forumId) })
      try { localStorage.setItem('zonefree-forums', JSON.stringify(nouveaux)) } catch (e) {}
      return nouveaux
    })
    var suppressed = JSON.parse(localStorage.getItem('zonefree-suppressed') || '[]')
    if (suppressed.indexOf(String(forumId)) === -1) {
      suppressed.push(String(forumId))
      localStorage.setItem('zonefree-suppressed', JSON.stringify(suppressed))
    }
    if (activeForum && String(activeForum.id) === String(forumId)) goHome()
    gun.get('zonefree-registry').get(String(forumId)).put({
      id: String(forumId), name: 'deleted', deleted: true
    }, function(ack) {
      console.log('[DELETE ACK]', ack)
    })
  }

  var supprimerTopic = function(forumId, topicId) {
    setForums(function(prev) {
      var nouveaux = prev.map(function(f) {
        if (String(f.id) !== String(forumId)) return f
        var filteredTopics = (f.topics || []).filter(function(t) { return String(t.id) !== String(topicId) })
        return Object.assign({}, f, { topics: filteredTopics })
      })
      try { localStorage.setItem('zonefree-forums', JSON.stringify(nouveaux)) } catch (e) {}
      return nouveaux
    })
    setActiveForum(function(prev) {
      if (!prev || String(prev.id) !== String(forumId)) return prev
      var filteredTopics = (prev.topics || []).filter(function(t) { return String(t.id) !== String(topicId) })
      return Object.assign({}, prev, { topics: filteredTopics })
    })
    if (activeTopic && String(activeTopic.id) === String(topicId)) goForum()
    try {
      gun.get('zonefree-topics-' + String(forumId)).get(String(topicId)).put({
        id: String(topicId), deleted: true, title: '', content: ''
      })
    } catch (e) { console.warn('supprimerTopic Gun error:', e) }
  }

  var supprimerConversation = function(convId) {
    setMessages(function(prev) {
      var next = (prev || []).filter(function(c) { return String(c.id) !== String(convId) })
      try { localStorage.setItem('zonefree-messages', JSON.stringify(next)) } catch (e) {}
      return next
    })
    setActiveConversation(function(prev) {
      if (!prev || String(prev.id) !== String(convId)) return prev
      return null
    })
  }

  var supprimerReponse = function(forumId, topicId, replyId) {
    var updateReplies = function(topics) {
      return (topics || []).map(function(t) {
        if (String(t.id) !== String(topicId)) return t
        var filtered = (t.replies || []).filter(function(r) { return String(r.id) !== String(replyId) })
        return Object.assign({}, t, { replies: filtered })
      })
    }
    setForums(function(prev) {
      var nouveaux = prev.map(function(f) {
        if (String(f.id) !== String(forumId)) return f
        return Object.assign({}, f, { topics: updateReplies(f.topics) })
      })
      try { localStorage.setItem('zonefree-forums', JSON.stringify(nouveaux)) } catch (e) {}
      return nouveaux
    })
    setActiveForum(function(prev) {
      if (!prev || String(prev.id) !== String(forumId)) return prev
      return Object.assign({}, prev, { topics: updateReplies(prev.topics) })
    })
    setActiveTopic(function(prev) {
      if (!prev || String(prev.id) !== String(topicId)) return prev
      var filtered = (prev.replies || []).filter(function(r) { return String(r.id) !== String(replyId) })
      return Object.assign({}, prev, { replies: filtered })
    })
    try {
      var reponseKey = String(forumId) + '-' + String(topicId)
      gun.get('zonefree-replies-' + reponseKey).get(String(replyId)).put({
        id: String(replyId), deleted: true, content: '', author: ''
      })
    } catch (e) { console.warn('supprimerReponse Gun error:', e) }
  }

  // ═══════════════════ COMPUTED ═══════════════════
  var joursRestants = expiration
    ? Math.max(0, Math.ceil((expiration - new Date()) / (1000 * 60 * 60 * 24)))
    : 0

  var inputStyle = {
    display: 'block', width: '100%', padding: '10px 14px', borderRadius: 8,
    border: '1.5px solid #30363d', background: dark ? '#0d1117' : '#f8f9ff',
    color: dark ? '#e6edf3' : '#1a1a2e', fontSize: 15, marginBottom: 16,
    marginTop: 6, boxSizing: 'border-box', fontFamily: 'inherit'
  }
  var inputStyleCenter = Object.assign({}, inputStyle, { textAlign: 'center', fontWeight: 700, fontSize: 18 })
  var inputStyleResize = Object.assign({}, inputStyle, { resize: 'vertical' })


  var topicsBase = activeForum?.topics.filter(function(t) {
    return t.title.toLowerCase().includes(rechercheTopic.toLowerCase()) ||
      t.author.toLowerCase().includes(rechercheTopic.toLowerCase())
  }) || []
  var topicsSorted = sortTopics(topicsBase, activeForum?.id)
  var totalPages = Math.ceil(topicsSorted.length / TOPICS_PAR_PAGE)
  var pageNums = []
  for (var pi = 1; pi <= totalPages; pi++) { pageNums.push(pi) }
  var topicsPaginated = topicsSorted.slice((currentPage - 1) * TOPICS_PAR_PAGE, currentPage * TOPICS_PAR_PAGE)
  var forumsFiltered = forums.filter(function(f) {
    return f.name.toLowerCase().includes(recherche.toLowerCase()) ||
      f.description.toLowerCase().includes(recherche.toLowerCase())
  })

  // ═══════════════════ HELPERS RENDER ═══════════════════
  // eslint-disable-next-line no-unused-vars
  function renderContenu(msg) {
    if (!msg) return ''
    var c = msg.content || msg
    if (typeof c !== 'string') return JSON.stringify(c)
    try {
      var parsed = JSON.parse(c)
      if (parsed && parsed.e) return '[encrypted message]'
      return c
    } catch(e) { return c }
  }

  // ═══════════════════ GUN P2P TRANSPORT ═══════════════════
  function transporterMessage(conv, msg) {
    try {
      if (!conv || !conv.key || !msg || !msg.id) return
      var flat = {
        id: msg.id,
        from: msg.from || '',
        fromAddr: msg.fromAddr || '',
        to: msg.to || '',
        toAddr: msg.toAddr || '',
        content: typeof msg.content === 'string' ? msg.content : String(msg.content || ''),
        timestamp: msg.timestamp || Date.now(),
        type: msg.type || 'text',
        date: msg.date || new Date().toLocaleDateString('fr-FR')
      }
      gun.get(hashConvKey(conv.key)).get(String(msg.id)).put(flat)
    } catch (e) {
      console.warn('transporterMessage error:', e)
    }
  }

  // ═══════════════════ RENDER ═══════════════════
  return (
    <div>

      {/* ══════════════ HEADER ══════════════ */}
      <header className="header" style={{
        display: 'flex', flexWrap: 'wrap',
        alignItems: 'center', justifyContent: 'space-between',
        gap: '8px', padding: '8px 12px'
      }}>
        <div className="logo" onClick={goHome} style={{ cursor: 'pointer' }}>
          Blabla<span>.Privacy</span>
        </div>
        <div className="header-actions" style={{
          display: 'flex', alignItems: 'center',
          flexWrap: 'wrap', gap: '8px',
          padding: '8px 12px',
          position: 'relative', zIndex: 100,
          justifyContent: 'flex-end',
          maxWidth: '70vw'
        }}>
          <button className="btn btn-ghost" onClick={function() { setDark(!dark) }} style={{ minWidth: '36px', minHeight: '36px' }}>{dark ? '☀️' : '🌙'}</button>
          {account && (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <button className="btn btn-ghost" onClick={function() { setPage('messages') }} style={{ fontSize: 16, minWidth: '36px', minHeight: '36px' }}>
                ✉️
              </button>
              {unreadCount > 0 && React.createElement('span', {
                style: {
                  position: 'absolute', top: '-4px', right: '-4px',
                  background: '#ef4444', color: '#fff',
                  borderRadius: '50%', width: '18px', height: '18px',
                  fontSize: '11px', fontWeight: 'bold',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  pointerEvents: 'none', zIndex: 10
                }
              }, unreadCount > 9 ? '9+' : String(unreadCount))}
            </div>
          )}
          <button className="btn btn-ghost" onClick={function() { setPage('profil') }} style={{ fontSize: 16, minWidth: '36px', minHeight: '36px' }}>👤</button>
          {account ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button className="btn btn-ghost" onClick={disconnectAll} title="Disconnect" style={{ fontSize: 14, padding: '6px 10px' }}>
                ⏏️
              </button>
              <span className="wallet-addr">{udDomain || pseudo || shortAddr(account)}</span>
              {estAbonne
                ? <span className="badge-abonne">✓ Subscribed</span>
                : <button className="btn btn-primary" onClick={sAbonner} style={{ fontSize: 13, padding: '6px 14px' }} disabled={loadingAbo}>
                    {loadingAbo ? <span className="spinner">Transaction...</span> : estGratuit ? '🎁 Free!' : `Subscribe ${prixEnETH} ETH`}
                  </button>
              }
            </div>
          ) : (
            <button className="btn btn-wallet" onClick={function() { openModal({ view: 'Connect' }) }}>
              {isConnected ? shortAddr(address) : 'Connect'}
            </button>

          )}
        </div>
      </header>

      {/* ══════════════ BANNIÈRE 300 GRATUITS ══════════════ */}
      {account && !estAbonne && estGratuit && !['profil', 'messages', 'conversation'].includes(page) && (
        <div style={{ background: 'linear-gradient(90deg,#22c55e22,#6366f122)', border: '1.5px solid #22c55e', borderRadius: 12, margin: '16px auto', maxWidth: 860, padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ margin: 0, fontSize: 14 }}>
            🎁 <strong>Early Adopter!</strong> {maxGratuit - totalAbonnes} free spots remaining ({totalAbonnes}/{maxGratuit})
          </p>
          <button className="btn btn-primary" onClick={sAbonner} disabled={loadingAbo} style={{ fontSize: 13, padding: '8px 20px', background: '#22c55e' }}>
            {loadingAbo ? <span className="spinner">Transaction...</span> : '🎁 Join FOR FREE'}
          </button>
        </div>
      )}

      {/* ══════════════ BANNIÈRE ABONNEMENT PAYANT ══════════════ */}
      {account && !estAbonne && !estGratuit && !['profil', 'messages', 'conversation'].includes(page) && (
        <div style={{ background: 'linear-gradient(90deg,#f59e0b22,#6366f122)', border: '1.5px solid #f59e0b', borderRadius: 12, margin: '16px auto', maxWidth: 860, padding: '14px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ margin: 0, fontSize: 14 }}><strong>You're not subscribed.</strong> Join Blabla.Privacy for ~$2/month in ETH.</p>
          <button className="btn btn-primary" onClick={sAbonner} disabled={loadingAbo} style={{ fontSize: 13, padding: '8px 20px' }}>
            {loadingAbo ? <span className="spinner">Transaction...</span> : `Subscribe ${prixEnETH} ETH — 30 days`}
          </button>
        </div>
      )}

      {/* ══════════════ PAGE MESSAGES ══════════════ */}
      {page === 'messages' && account && (
        <MessagerieErrorBoundary>
        <div className="forum-page">
          {React.createElement('button', {
            className: 'back-btn',
            onClick: function(e) { e.preventDefault(); e.stopPropagation(); goHome() },
            onTouchEnd: function(e) { e.preventDefault(); goHome() },
            style: {
              minHeight: '44px', touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              position: 'relative', zIndex: 999
            }
          }, '← Back to home')}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <h2 style={{ fontSize: 22 }}>✉️ Messages {naclKeyPair ? '🔐 NaCl E2E' : 'local'}</h2>
            <div style={{ display: 'flex', gap: 8 }}>
              {!naclKeyPair && (
                <button className="btn btn-ghost" onClick={initNaclKeys} disabled={naclLoading} style={{ fontSize: 12 }}>
                  {naclLoading ? <span className="spinner">Signing...</span> : '🔐 Enable E2E'}
                </button>
              )}
              <button className="btn btn-primary" onClick={function() { setShowNewConversation(true) }}>+ New</button>
            </div>
          </div>

          <div style={{ background: naclKeyPair ? '#22c55e11' : '#6366f111', border: `1.5px solid ${naclKeyPair ? '#22c55e44' : '#6366f133'}`, borderRadius: 10, padding: '10px 16px', marginBottom: 20, fontSize: 13 }}>
            {naclKeyPair
              ? '🔐 NaCl encryption active — Curve25519 + XSalsa20 + Poly1305'
              : '💾 Plain text messages — Click "Enable E2E" to encrypt'}
          </div>

          {messages.length === 0
            ? <div className="no-results" style={{ textAlign: 'center', padding: 40 }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>✉️</div>
                <p style={{ opacity: 0.5 }}>No messages. Start a conversation!</p>
              </div>
            : <div className="messages-list">
                {messages.map(function(conv) {
                  var other = conv.participants.find(function(p) { return !isMe(p) }) || conv.participants[0]
                  var lastMsg = conv.msgs && conv.msgs.length > 0 ? conv.msgs[conv.msgs.length - 1] : null
                  var preview = ''
                  if (lastMsg && lastMsg.content) {
                    if (typeof lastMsg.content === 'string') {
                      if (lastMsg.content.indexOf('{"enc":') === 0) {
                        preview = '🔒 Encrypted message'
                      } else {
                        preview = lastMsg.content.substring(0, 30)
                      }
                    } else {
                      preview = '[message]'
                    }
                  } else {
                    preview = 'Start conversation...'
                  }
                  var accLow = String(account || '').toLowerCase()
                  var participants = (conv.participants || []).map(function(p) { return String(p).toLowerCase() })
                  var peutSupprimerConv = (account && participants.indexOf(accLow) !== -1)
                    || (account && accLow === SUPER_ADMIN.toLowerCase())
                  var convChiffree = !!convChiffrees[conv.id]
                  return React.createElement('div', {
                    key: conv.id,
                    className: 'conversation-item',
                    onClick: function() { ouvrirConversation(conv) },
                    style: { display: 'flex', alignItems: 'center', gap: 8 }
                  },
                    React.createElement('div', {className: 'conv-avatar'}, '🔐'),
                    React.createElement('div', {className: 'conv-info', style: { flex: 1, minWidth: 0 }},
                      React.createElement('div', {className: 'conv-name'},
                        React.createElement('span', {
                          title: convChiffree ? 'Encryption available' : 'No known key',
                          style: { marginRight: 6, fontSize: 14 }
                        }, convChiffree ? '🔒' : '🔓'),
                        getPseudoOrAddr(other)
                      ),
                      React.createElement('div', {className: 'conv-preview'}, preview)
                    ),
                    peutSupprimerConv && React.createElement('button', {
                      onClick: function(e) {
                        e.preventDefault()
                        e.stopPropagation()
                        supprimerConversation(conv.id)
                      },
                      onPointerUp: function(e) { e.stopPropagation() },
                      title: 'Delete this conversation',
                      style: {
                        background: 'transparent', color: '#ef4444', border: 'none',
                        cursor: 'pointer', fontSize: '16px', padding: '6px 10px',
                        borderRadius: '6px', lineHeight: 1, flexShrink: 0,
                        touchAction: 'manipulation',
                        WebkitTapHighlightColor: 'transparent'
                      }
                    }, '🗑️')
                  )
                })}
              </div>
          }

          {(function() {
            var membres = membresListe || []
            var lowerAcc = String(account || '').toLowerCase()
            var autres = membres.filter(function(m) {
              return m && m.address && String(m.address).toLowerCase() !== lowerAcc
            })
            return React.createElement('div', { style: { marginTop: 28 } },
              React.createElement('h3', { style: { fontSize: 16, marginBottom: 12, opacity: 0.8 } }, '👥 Online members'),
              autres.length === 0
                ? React.createElement('div', { style: { opacity: 0.5, fontSize: 13, padding: 12 } }, 'No members known yet.')
                : React.createElement('div', { className: 'membres-list', style: { display: 'flex', flexDirection: 'column', gap: 8 } },
                    autres.map(function(m) {
                      var isOnline = m.lastSeen && (Date.now() - m.lastSeen) < 5 * 60 * 1000
                      var label = (m.pseudo && String(m.pseudo).trim()) ? m.pseudo : shortAddr(m.address)
                      var memberAddrLow = String(m.address || '').toLowerCase()
                      var memberHasKey = !!pubKeysKnown[memberAddrLow]
                      if (!memberHasKey && memberAddrLow) {
                        try { memberHasKey = !!localStorage.getItem('zonefree-nacl-pub-' + memberAddrLow) } catch (e) {}
                      }
                      return React.createElement('div', {
                        key: m.address,
                        style: {
                          display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
                          background: dark ? '#0d1117' : '#f8f9ff',
                          border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0',
                          borderRadius: 10
                        }
                      },
                        React.createElement('div', { style: { fontSize: 22 } }, m.avatar || '👤'),
                        React.createElement('div', { style: { flex: 1, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 } },
                          React.createElement('span', {
                            title: memberHasKey ? 'Public key known' : 'No public key',
                            style: { fontSize: 13 }
                          }, memberHasKey ? '🔒' : '🔓'),
                          React.createElement('span', null, label)
                        ),
                        React.createElement('span', {
                          title: isOnline ? 'Online' : 'Offline',
                          style: {
                            width: '12px', height: '12px', borderRadius: '50%',
                            background: isOnline ? '#22c55e' : '#6b7280',
                            display: 'inline-block', flexShrink: 0,
                            boxShadow: isOnline ? '0 0 6px #22c55e' : 'none'
                          }
                        }),
                        React.createElement('button', {
                          className: 'btn btn-ghost',
                          style: { fontSize: 14, padding: '6px 10px' },
                          onClick: function() { demarrerConversationAvec(m.address) }
                        }, '💬')
                      )
                    })
                  )
            )
          })()}

          {showNewConversation && (
            <div style={{ position: 'fixed', inset: 0, background: '#0008', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
              <div style={{ background: dark ? '#161b22' : 'white', borderRadius: 16, padding: 32, width: 440, border: '1.5px solid #6366f1' }}>
                <h2 style={{ marginBottom: 8, color: '#6366f1' }}>✉️ New message</h2>
                {naclKeyPair && <p style={{ fontSize: 13, opacity: 0.6, marginBottom: 16 }}>NaCl encryption active — enter recipient address</p>}
                <label style={{ fontSize: 13, opacity: 0.7 }}>Recipient address</label>
                <input value={newMessageTo} onChange={function(e) { setNewMessageTo(e.target.value) }} style={inputStyle} placeholder="0x... or 0xABCD...1234" />
                <div style={{ display: 'flex', gap: 12 }}>
                  <button className="btn btn-primary" onClick={demarrerConversation} style={{ flex: 1 }}>Start</button>
                  <button className="btn btn-ghost" onClick={function() { setShowNewConversation(false) }} style={{ flex: 1 }}>Cancel</button>
                </div>
              </div>
            </div>
          )}
        </div>
        </MessagerieErrorBoundary>
      )}

      {/* ══════════════ PAGE CONVERSATION LOCALE ══════════════ */}
      {page === 'conversation' && activeConversation && (
        <div className="forum-page" style={{ position: 'relative', overflow: 'visible' }}>
          <div style={{ position: 'relative', zIndex: 999, overflow: 'visible', marginBottom: 12 }}>
          {React.createElement('button', {
            onClick: function(e) {
              e.preventDefault()
              e.stopPropagation()
              activeConvKeyRef.current = null
              setPage('messages')
              setActiveConversation(null)
            },
            onTouchEnd: function(e) {
              e.preventDefault()
              activeConvKeyRef.current = null
              setPage('messages')
              setActiveConversation(null)
            },
            style: {
              display: 'inline-flex', alignItems: 'center',
              padding: '12px 20px', fontSize: '16px', cursor: 'pointer',
              background: 'none', border: '2px solid #6c47ff',
              borderRadius: '8px', color: '#6c47ff',
              minHeight: '48px', minWidth: '80px',
              touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent',
              userSelect: 'none', WebkitUserSelect: 'none',
              position: 'relative', zIndex: 999
            }
          }, '← Back')}
          </div>
          <h2>💬 {getPseudoOrAddr(activeConversation.participants.find(function(p) { return !isMe(p) }) || activeConversation.participants[0])}</h2>
          {(function() {
            var otherConv = null
            if (activeConversation && activeConversation.participants) {
              for (var pc = 0; pc < activeConversation.participants.length; pc++) {
                if (!isMe(activeConversation.participants[pc])) { otherConv = activeConversation.participants[pc]; break }
              }
            }
            var otherConvLow = String(otherConv || '').toLowerCase()
            var otherHasKey = otherConvLow
              ? (!!pubKeysKnown[otherConvLow] || !!localStorage.getItem('zonefree-nacl-pub-' + otherConvLow))
              : false
            var chiffreActif = !!naclKeyPair && otherHasKey
            return React.createElement('div', {
              style: {
                fontSize: 12,
                marginTop: -6,
                marginBottom: 12,
                color: chiffreActif ? '#22c55e' : '#f59e0b',
                opacity: 0.85
              }
            }, chiffreActif ? '🔒 Encryption active' : '🔓 Messages not encrypted')
          })()}
          <div className="chat-container">
            {activeConversation.msgs.length === 0 && (
              <div style={{textAlign:'center', opacity:0.4, marginTop:40}}>No messages — Say hi! 👋</div>
            )}
            {activeConversation.msgs.map(function(m) {
              var estMoi = isMe(m.from) || (m.fromAddr && String(m.fromAddr).toLowerCase() === String(account || '').toLowerCase())
              var contenu = ''
              if (m && m.content) {
                if (typeof m.content === 'string') {
                  contenu = m.content
                } else {
                  contenu = String(m.content)
                }
              }
              var displayContent = m.content
              if (m.content && typeof m.content === 'string' && m.content.indexOf('{"enc":') === 0) {
                try {
                  var mySecRKey = naclKeyPair ? naclKeyPair.secretKey : null
                  var parsed = JSON.parse(m.content)
                  var otherPartR = ''
                  if (activeConversation && activeConversation.participants) {
                    for (var pi = 0; pi < activeConversation.participants.length; pi++) {
                      var pp = String(activeConversation.participants[pi]).toLowerCase()
                      if (pp !== String(account || '').toLowerCase()) { otherPartR = pp; break }
                    }
                  }
                  var senderPubB64 = otherPartR ? localStorage.getItem('zonefree-nacl-pub-' + otherPartR) : null
                  if (mySecRKey && senderPubB64) {
                    var encBytes = new Uint8Array(atob(parsed.enc).split('').map(function(c) { return c.charCodeAt(0) }))
                    var nonceBytes = new Uint8Array(atob(parsed.nonce).split('').map(function(c) { return c.charCodeAt(0) }))
                    var senderPub = new Uint8Array(atob(senderPubB64).split('').map(function(c) { return c.charCodeAt(0) }))
                    var decrypted = nacl.box.open(encBytes, nonceBytes, senderPub, mySecRKey)
                    displayContent = decrypted ? new TextDecoder().decode(decrypted) : '[wrong key]'
                  } else {
                    displayContent = '[missing key]'
                  }
                } catch (e) {
                  displayContent = '[decryption error]'
                }
              }
              contenu = typeof displayContent === 'string' ? displayContent : String(displayContent || '')
              var wrapperClass = estMoi ? 'bubble-wrapper sent' : 'bubble-wrapper received'
              var bubbleClass = estMoi ? 'bubble sent' : 'bubble received'
              return React.createElement('div', {key: m.id, className: wrapperClass},
                m.type === 'image'
                  ? React.createElement('img', {src: contenu, alt: 'img', style: {maxWidth:240, borderRadius:12}})
                  : React.createElement('div', {className: bubbleClass}, contenu),
                React.createElement('div', {className: 'bubble-time'}, m.date)
              )
            })}
          </div>
          {React.createElement('div', {
            className: 'message-input-bar',
            style: {
              display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: '8px',
              padding: '12px 16px', width: '100%', maxWidth: '100%', boxSizing: 'border-box',
              borderTop: '1px solid #333', background: '#111'
            }
          },
            React.createElement('input', {
              type: 'file', accept: 'image/*',
              id: 'inputImageMsg',
              style: { display: 'none' },
              onChange: function(e) {
                if (e.target.files && e.target.files[0]) {
                  envoyerImage(e)
                }
              }
            }),
            React.createElement('button', {
              onClick: function() {
                var el = document.getElementById('inputImageMsg')
                if (el) el.click()
              },
              style: {
                background: 'none', border: '1px solid #555', borderRadius: '8px',
                color: '#fff', fontSize: '20px', cursor: 'pointer',
                padding: '6px 10px', flexShrink: 0
              }
            }, '🖼️'),
            React.createElement('input', {
              type: 'text',
              className: 'message-input',
              placeholder: 'Write a message... (Enter)',
              value: newMessage,
              onChange: function(e) { setNewMessage(e.target.value) },
              onKeyDown: function(e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); envoyerMessage() } },
              style: {
                flex: '1 1 auto', minWidth: 0, maxWidth: '100%',
                minHeight: '44px', fontSize: '16px',
                padding: '10px 14px', boxSizing: 'border-box',
                borderRadius: '10px', border: '1px solid #444',
                background: '#222', color: '#fff', outline: 'none'
              }
            }),
            React.createElement('button', {
              className: 'send-btn',
              onClick: function() { envoyerMessage() },
              style: {
                background: '#6c47ff', border: 'none', borderRadius: '8px',
                color: '#fff', fontSize: '18px', cursor: 'pointer',
                padding: '8px 14px', flexShrink: 0
              }
            }, '➤')
          )}
        </div>
      )}

      {/* ══════════════ PAGE PROFIL ══════════════ */}
      {page === 'profil' && account && (
        <div className="forum-page">
          {React.createElement('button', {
            className: 'back-btn',
            onClick: function(e) { e.preventDefault(); e.stopPropagation(); goHome() },
            onTouchEnd: function(e) { e.preventDefault(); goHome() },
            style: {
              minHeight: '44px', touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              position: 'relative', zIndex: 999
            }
          }, '← Back to home')}

          {/* CARTE IDENTITÉ */}
          <div style={{ borderRadius: 20, padding: 36, marginBottom: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid #6366f1', textAlign: 'center' }}>
            <div style={{ fontSize: 64, marginBottom: 12 }}>🦊</div>
            {editPseudo ? (
              <div style={{ marginBottom: 16 }}>
                <input value={newPseudo} onChange={function(e) { setNewPseudo(e.target.value) }}
                  style={inputStyleCenter}
                  placeholder="Your nickname..." autoFocus />
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                  <button className="btn btn-primary" onClick={function() {
                    var clean = newPseudo.trim()
                    setPseudo(clean)
                    localStorage.setItem('zonefree-pseudo', clean)
                    setEditPseudo(false)
                  }}>✓ Save</button>
                  <button className="btn btn-ghost" onClick={function() { setEditPseudo(false) }}>Cancel</button>
                </div>
              </div>
            ) : (
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{pseudo || udDomain || shortAddr(account)}</div>
                <button className="btn btn-ghost" onClick={function() { setNewPseudo(pseudo); setEditPseudo(true) }}
                  style={{ fontSize: 12, marginTop: 8, opacity: 0.7 }}>
                  ✏️ Edit nickname
                </button>
              </div>
            )}
            {udDomain && <div style={{ fontSize: 13, color: '#6366f1', marginBottom: 8 }}>🌐 {udDomain}</div>}
            <div style={{ fontSize: 12, opacity: 0.4, marginBottom: 20, fontFamily: 'monospace' }}>{account}</div>
            {estAbonne
              ? <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#22c55e22', border: '1.5px solid #22c55e', borderRadius: 20, padding: '8px 20px' }}>
                  <span>✅</span><span style={{ color: '#22c55e', fontWeight: 700 }}>Active subscriber</span>
                </div>
              : <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#f59e0b22', border: '1.5px solid #f59e0b', borderRadius: 20, padding: '8px 20px' }}>
                  <span>⚠️</span><span style={{ color: '#f59e0b', fontWeight: 700 }}>Not subscribed</span>
                </div>
            }
          </div>

          {/* PRIX */}
          <div style={{ borderRadius: 16, padding: 20, marginBottom: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid #6366f1', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 12, opacity: 0.5, marginBottom: 4 }}>SUBSCRIPTION PRICE (Chainlink)</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: '#6366f1' }}>{estGratuit ? '🎁 FREE' : `${prixEnETH} ETH`}</div>
              <div style={{ fontSize: 13, opacity: 0.6 }}>~2.00 EUR / 30 days</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 40 }}>{estGratuit ? '🎁' : '⟠'}</div>
              {totalAbonnes !== null && (
                <div style={{ fontSize: 12, color: estGratuit ? '#22c55e' : '#6366f1', fontWeight: 700 }}>
                  {totalAbonnes}/{maxGratuit} subscribers
                </div>
              )}
            </div>
          </div>

          {/* DÉTAILS */}
          <div style={{ borderRadius: 16, padding: 28, marginBottom: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
            <h3 style={{ marginBottom: 20 }}>📋 Subscription details</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              {[
                { label: 'STATUS', value: estAbonne ? 'Active' : 'Inactive', color: estAbonne ? '#22c55e' : '#f59e0b' },
                { label: 'DAYS LEFT', value: estAbonne ? `${joursRestants} days` : '—', color: joursRestants > 7 ? '#22c55e' : '#f59e0b' },
                { label: 'EXPIRATION', value: expiration ? expiration.toLocaleDateString('en-US') : '—', color: null },
                { label: 'PRICE', value: estGratuit ? 'FREE 🎁' : `${prixEnETH} ETH`, color: '#6366f1' }
              ].map(function(item, i) { return (
                <div key={i} style={{ borderRadius: 12, padding: 20, background: dark ? '#0d1117' : '#f8f9ff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
                  <div style={{ fontSize: 12, opacity: 0.5, marginBottom: 6 }}>{item.label}</div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: item.color || 'inherit' }}>{item.value}</div>
                </div>
              )})}
            </div>
            {estAbonne && (
              <div style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, opacity: 0.6, marginBottom: 8 }}>
                  <span>Progress</span><span>{joursRestants}/30 days left</span>
                </div>
                <div style={{ background: dark ? '#0d1117' : '#e2e8f0', borderRadius: 8, height: 10, overflow: 'hidden' }}>
                  <div style={{ height: '100%', borderRadius: 8, width: `${(joursRestants / 30) * 100}%`, background: joursRestants > 7 ? 'linear-gradient(90deg,#6366f1,#22c55e)' : 'linear-gradient(90deg,#f59e0b,#ef4444)', transition: 'width 0.5s ease' }} />
                </div>
              </div>
            )}
          </div>

          {/* STATISTIQUES */}
          <div style={{ borderRadius: 16, padding: 28, marginBottom: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
            <h3 style={{ marginBottom: 20 }}>📊 My statistics</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              {[
                { label: 'Topics created', value: forums.reduce(function(a, f) { return a + f.topics.filter(function(t) { return t.author === displayName(account) }).length }, 0), icon: '📝' },
                { label: 'Replies', value: forums.reduce(function(a, f) { return a + f.topics.reduce(function(b, t) { return b + t.replies.filter(function(r) { return r.author === displayName(account) }).length }, 0) }, 0), icon: '💬' },
                { label: 'Messages', value: messages.reduce(function(a, c) { return a + c.msgs.filter(function(m) { return m.from === shortAddr(account) }).length }, 0), icon: '✉️' }
              ].map(function(stat, i) { return (
                <div key={i} style={{ borderRadius: 12, padding: 20, textAlign: 'center', background: dark ? '#0d1117' : '#f8f9ff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{stat.icon}</div>
                  <div style={{ fontSize: 28, fontWeight: 800, color: '#6366f1' }}>{stat.value}</div>
                  <div style={{ fontSize: 12, opacity: 0.6, marginTop: 4 }}>{stat.label}</div>
                </div>
              )})}
            </div>
          </div>

          {/* PARAMÈTRES AVANCÉS */}
          <div style={{ borderRadius: 16, padding: 28, marginBottom: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
            <h3 style={{ marginBottom: 24 }}>⚙️ Advanced settings</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

              {/* 🔔 NOTIFICATIONS */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderRadius: 12, background: dark ? '#0d1117' : '#f8f9ff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
                <div>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>🔔 Notifications</div>
                  <div style={{ fontSize: 12, opacity: 0.6 }}>Reply & message alerts</div>
                </div>
                {notifPermission === 'granted'
                  ? <span style={{ fontSize: 13, color: '#22c55e', fontWeight: 700, background: '#22c55e22', border: '1px solid #22c55e44', borderRadius: 20, padding: '6px 14px' }}>✅ Enabled</span>
                  : notifPermission === 'denied'
                    ? <span style={{ fontSize: 12, color: '#ef4444', background: '#ef444411', border: '1px solid #ef444444', borderRadius: 20, padding: '6px 14px' }}>🚫 Blocked (browser)</span>
                    : <button className="btn btn-primary" onClick={demanderNotifications} style={{ fontSize: 13, padding: '8px 18px' }}>Enable</button>
                }
              </div>

              {/* 🔐 NaCl E2E */}
              <div style={{ padding: '16px 20px', borderRadius: 12, background: dark ? '#0d1117' : '#f8f9ff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>🔐 NaCl encryption</div>
                    <div style={{ fontSize: 12, opacity: 0.6 }}>
                      {naclKeyPair ? 'Curve25519 + XSalsa20 + Poly1305 active' : 'End-to-end message encryption'}
                    </div>
                  </div>
                  {naclKeyPair
                    ? <span style={{ fontSize: 13, color: '#22c55e', fontWeight: 700, background: '#22c55e22', border: '1px solid #22c55e44', borderRadius: 20, padding: '6px 14px' }}>✅ Active</span>
                    : <button className="btn btn-primary" onClick={initNaclKeys} disabled={naclLoading} style={{ fontSize: 13, padding: '8px 18px' }}>
                        {naclLoading ? <span className="spinner">Signing...</span> : 'Enable'}
                      </button>
                  }
                </div>
              </div>

              {/* 🌐 UNSTOPPABLE DOMAIN */}
              <div style={{ padding: '16px 20px', borderRadius: 12, background: dark ? '#0d1117' : '#f8f9ff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>🌐 Unstoppable Domain</div>
                    <div style={{ fontSize: 12, opacity: 0.6 }}>
                      {udDomain
                        ? <span style={{ color: '#6366f1', fontWeight: 700 }}>{udDomain}</span>
                        : 'No .x domain detected for this wallet'}
                    </div>
                  </div>
                  <button className="btn btn-ghost" onClick={detecterUD} style={{ fontSize: 13, padding: '8px 18px' }}>
                    🔍 Detect
                  </button>
                </div>
              </div>

            </div>
          </div>

          {!estAbonne && (
            <div style={{ textAlign: 'center', marginTop: 8 }}>
              <button className="btn btn-primary" onClick={sAbonner} disabled={loadingAbo} style={{ fontSize: 16, padding: '14px 36px' }}>
                {loadingAbo ? <span className="spinner">Transaction...</span> : estGratuit ? '🎁 Join FOR FREE' : `Subscribe ${prixEnETH} ETH ~$2/month`}
              </button>
            </div>
          )}
          <div style={{ textAlign: 'center', marginTop: 24, opacity: 0.5, fontSize: 13 }}>
            <a href={`https://etherscan.io/address/${account}`} target="_blank" rel="noreferrer" style={{ color: '#6366f1' }}>
              View on Etherscan Mainnet
            </a>
          </div>
        </div>
      )}

      {/* ══════════════ PAGE HOME ══════════════ */}
      {page === 'home' && (
        <div>
          <div style={{
            background: dark ? '#1f2937' : '#f3f4f6',
            borderRadius: 12,
            padding: 16,
            marginBottom: 20,
            border: '1px solid ' + (dark ? '#374151' : '#e5e7eb')
          }}>
            <div style={{ fontWeight: 700, marginBottom: 10, fontSize: 15 }}>
              ⚡ Flash Chat — messages disappear after 1h
            </div>
            {(!flashPseudo || flashEditPseudo) ? (
              <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                <input
                  type="text"
                  placeholder="Enter a nickname"
                  value={flashPseudo}
                  onChange={function(e) { setFlashPseudo(e.target.value) }}
                  onKeyDown={function(e) {
                    if (e.key === 'Enter' && flashPseudo.trim()) setFlashEditPseudo(false)
                  }}
                  style={{
                    flex: 1, padding: '8px 12px', borderRadius: 8,
                    border: '1px solid ' + (dark ? '#4b5563' : '#d1d5db'),
                    background: dark ? '#111827' : '#fff',
                    color: dark ? '#fff' : '#000'
                  }}
                />
                <button
                  onClick={function() {
                    if (flashPseudo.trim()) setFlashEditPseudo(false)
                  }}
                  style={{
                    padding: '8px 16px', borderRadius: 8, border: 'none',
                    background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600
                  }}
                >OK</button>
              </div>
            ) : (
              <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 10 }}>
                Posting as <strong>{flashPseudo}</strong>{' '}
                <button
                  onClick={function() { setFlashEditPseudo(true) }}
                  style={{
                    background: 'transparent', border: 'none', color: '#6366f1',
                    cursor: 'pointer', textDecoration: 'underline', padding: 0, fontSize: 13
                  }}
                >change</button>
              </div>
            )}
            <div style={{
              maxHeight: 200, overflowY: 'auto',
              background: dark ? '#111827' : '#fff',
              padding: 8, borderRadius: 8, marginBottom: 8,
              border: '1px solid ' + (dark ? '#374151' : '#e5e7eb')
            }}>
              {flashMessages.filter(function(m) {
                return (Date.now() - m.timestamp) < 3600000
              }).length === 0 ? (
                <div style={{ opacity: 0.5, fontSize: 13, textAlign: 'center', padding: 8 }}>
                  No messages yet…
                </div>
              ) : flashMessages.filter(function(m) {
                return (Date.now() - m.timestamp) < 3600000
              }).map(function(m) {
                return (
                  <div key={m.id} style={{ padding: '4px 0', fontSize: 14, wordBreak: 'break-word' }}>
                    <strong style={{ color: '#6366f1' }}>{m.pseudo}</strong>: {m.content}
                  </div>
                )
              })}
            </div>
            {flashPseudo && !flashEditPseudo && (
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text"
                  placeholder="Type a message..."
                  value={flashInput}
                  onChange={function(e) { setFlashInput(e.target.value) }}
                  onKeyDown={function(e) { if (e.key === 'Enter') sendFlashMessage() }}
                  style={{
                    flex: 1, padding: '8px 12px', borderRadius: 8,
                    border: '1px solid ' + (dark ? '#4b5563' : '#d1d5db'),
                    background: dark ? '#111827' : '#fff',
                    color: dark ? '#fff' : '#000'
                  }}
                />
                <button
                  onClick={function() { sendFlashMessage() }}
                  style={{
                    padding: '8px 16px', borderRadius: 8, border: 'none',
                    background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600
                  }}
                >Send</button>
              </div>
            )}
          </div>
          <div className="hero">
            <div className="badge">Decentralized • Free • Private</div>
            <h1><span>Blabla.Privacy</span></h1>
            <p>The decentralized forum where speech is free. Subscription secured by Ethereum.</p>
            {estGratuit && totalAbonnes !== null && (
              <div style={{ fontSize: 13, color: '#22c55e', marginTop: 8, fontWeight: 600 }}>
                🎁 {maxGratuit - totalAbonnes} free spots remaining!
              </div>
            )}
          </div>
          <div className="search-container">
            <span className="search-icon">🔍</span>
            <input className="search-input" placeholder="Search a channel..." value={recherche} onChange={function(e) { setRecherche(e.target.value) }} />
            {recherche && <button className="search-clear" onClick={function() { setRecherche('') }}>✕</button>}
          </div>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <button className="btn btn-primary" onClick={function() { setShowNewSalon(true) }} style={{ fontSize: 16, padding: '12px 28px' }}>
              + Create a new channel
            </button>
          </div>
          {forumsFiltered.length === 0
            ? <div className="no-results"><span>🔍</span><p>No channel found for <strong>{recherche}</strong></p></div>
            : <div className="forums-grid">
                {forumsFiltered.map(function(f) { return (
                  <div key={f.id} className="forum-card" onClick={function(e) {
                    if (e.target && e.target.closest && (
                      e.target.closest('button') ||
                      e.target.closest('[data-action]')
                    )) return
                    openForum(f)
                  }}>
                    <div className="forum-emoji">{f.emoji}</div>
                    <div className="forum-name">{f.name}</div>
                    <div className="forum-desc">{f.description}</div>
                    <div className="forum-meta">
                      <span>{f.topics.length} topics</span>
                      <span>{f.topics.reduce(function(a, t) { return a + t.replies.length }, 0)} replies</span>
                      {f.topics.some(function(t) { return t.pinned }) && <span>📌</span>}
                    </div>
                    {(function() {
                      var peutSupprimer = (account && f.creator &&
                        String(f.creator).toLowerCase() === String(account).toLowerCase())
                        || (account && String(account).toLowerCase() === SUPER_ADMIN.toLowerCase())
                      return peutSupprimer
                    })() && React.createElement('button', {
                      'data-action': 'supprimer',
                      onPointerUp: function(e) {
                        e.preventDefault()
                        e.stopPropagation()
                        supprimerSalon(f.id)
                      },
                      onClick: function(e) {
                        e.preventDefault()
                        e.stopPropagation()
                        supprimerSalon(f.id)
                      },
                      style: {
                        background: '#ef4444', color: '#fff', border: 'none',
                        borderRadius: '8px', padding: '12px 20px',
                        minHeight: '48px', fontSize: '15px', cursor: 'pointer',
                        touchAction: 'manipulation',
                        WebkitTapHighlightColor: 'transparent',
                        position: 'relative', zIndex: 1000,
                        display: 'block', width: '100%',
                        userSelect: 'none', WebkitUserSelect: 'none',
                        marginTop: 8
                      }
                    }, '🗑️ Delete')}
                  </div>
                )})}
              </div>
          }
        </div>
      )}

      {/* ══════════════ PAGE FORUM ══════════════ */}
      {page === 'forum' && activeForum && (
        <div className="forum-page" style={{ position: 'relative', overflow: 'visible' }}>
          <div style={{ position: 'relative', zIndex: 1000, display: 'block', overflow: 'visible' }}>
          {React.createElement('button', {
            className: 'back-btn',
            onClick: function(e) { e.preventDefault(); e.stopPropagation(); goHome() },
            onTouchEnd: function(e) { e.preventDefault(); e.stopPropagation(); goHome() },
            style: {
              minHeight: '44px', touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              position: 'relative', zIndex: 1000
            }
          }, '← Back to forums')}
          </div>
          <div className="forum-header">
            <h2>{activeForum.emoji} {activeForum.name}</h2>
            <p style={{ opacity: 0.6, marginTop: 6 }}>{activeForum.description}</p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
              <button className="new-topic-btn" onClick={function() { setShowNewTopic(true) }}>+ New topic</button>
              {(function() {
                var peutSupprimer = (account && activeForum.creator &&
                  String(activeForum.creator).toLowerCase() === String(account).toLowerCase())
                  || (account && String(account).toLowerCase() === SUPER_ADMIN.toLowerCase())
                if (!peutSupprimer) return null
                return React.createElement('button', {
                  onClick: function(e) {
                    e.preventDefault()
                    e.stopPropagation()
                    supprimerSalon(activeForum.id)
                    setActiveForum(null)
                  },
                  onPointerUp: function(e) {
                    e.stopPropagation()
                  },
                  style: {
                    background: '#ef4444', color: '#fff', border: 'none',
                    borderRadius: '12px', padding: '12px 24px',
                    fontSize: '14px', fontWeight: '600', cursor: 'pointer',
                    touchAction: 'manipulation',
                    WebkitTapHighlightColor: 'transparent'
                  }
                }, '🗑️ Delete this channel')
              })()}
            </div>
          </div>
          <div className="search-container" style={{ margin: '0 0 16px' }}>
            <span className="search-icon">🔍</span>
            <input className="search-input" placeholder="Search a topic..." value={rechercheTopic} onChange={function(e) { setRechercheTopic(e.target.value); setCurrentPage(1) }} />
            {rechercheTopic && <button className="search-clear" onClick={function() { setRechercheTopic('') }}>✕</button>}
          </div>
          <div className="sort-bar">
            <span style={{ fontSize: 13, opacity: 0.6 }}>Sort by </span>
            {[['date', 'Most recent'], ['popular', 'Popular'], ['replies', 'Most replies']].map(function(item) {
              var val = item[0]
              var label = item[1]
              return (
                <button key={val} className={'sort-btn ' + (sortBy === val ? 'active' : '')} onClick={function() { setSortBy(val); setCurrentPage(1) }}>{label}</button>
              )
            })}
          </div>
          {topicsPaginated.length === 0
            ? <div className="no-results"><span>🔍</span><p>No topics found.</p></div>
            : topicsPaginated.map(function(t) {
                var likeKey = activeForum.id + '-' + t.id
                var likeData = getLike(likeKey)
                var count = likeData.count
                var hasLiked = likeData.hasLiked
                return (
                  <div key={t.id} className="topic-card" onClick={function() { openTopic(t) }}>
                    <div style={{ flex: 1 }}>
                      <div className="topic-title">
                        {t.pinned && <span style={{ marginRight: 6 }}>📌</span>}
                        {t.title}
                      </div>
                      <div className="topic-meta">by {t.author} · {t.date}</div>
                      <div style={{ marginTop: 8 }} onClick={function(e) { e.stopPropagation() }}>
                        <button className={'like-btn ' + (hasLiked ? 'liked' : '')} onClick={function() { toggleLike(likeKey) }}>
                          ❤️ {count > 0 ? count : ''} Like
                        </button>
                        {estAbonne && (
                          <button className="like-btn" onClick={function(e) { e.stopPropagation(); togglePin(t.id) }} style={{ marginLeft: 8, opacity: 0.7 }}>
                            {t.pinned ? '📌 Unpin' : '📌 Pin'}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="topic-replies">{t.replies.length}</div>
                  </div>
                )
              })
          }
          {totalPages > 1 && (
            <div className="pagination">
              <button className="page-btn" disabled={currentPage === 1} onClick={function() { setCurrentPage(function(p) { return p - 1 }) }}>←</button>
              {pageNums.map(function(n) { return (
                <button key={n} className={'page-btn ' + (currentPage === n ? 'active' : '')} onClick={function() { setCurrentPage(n) }}>{n}</button>
              )})}
              <button className="page-btn" disabled={currentPage === totalPages} onClick={function() { setCurrentPage(function(p) { return p + 1 }) }}>→</button>
            </div>
          )}
        </div>
      )}

      {/* ══════════════ PAGE TOPIC ══════════════ */}
      {page === 'topic' && activeTopic && (
        <div className="forum-page" style={{ position: 'relative', overflow: 'visible' }}>
          <div style={{ position: 'relative', zIndex: 1000, display: 'block', overflow: 'visible' }}>
          {React.createElement('button', {
            className: 'back-btn',
            onClick: function(e) { e.preventDefault(); e.stopPropagation(); goForum() },
            onTouchEnd: function(e) { e.preventDefault(); e.stopPropagation(); goForum() },
            style: {
              minHeight: '44px', touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              position: 'relative', zIndex: 1000
            }
          }, '← Back ' + ((activeForum && activeForum.emoji) || '') + ' ' + ((activeForum && activeForum.name) || ''))}
          </div>
          <div style={{ borderRadius: 14, padding: 28, marginBottom: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid #6366f1' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
              <h2 style={{ fontSize: 22, marginBottom: 12, flex: 1 }}>
                {activeTopic.pinned && <span style={{ marginRight: 8 }}>📌</span>}
                {activeTopic.title}
              </h2>
              {(function() {
                var peutSuppr = (account && activeTopic.author &&
                  String(activeTopic.author).toLowerCase() === String(displayName(account)).toLowerCase())
                  || (account && String(account).toLowerCase() === SUPER_ADMIN.toLowerCase())
                if (!peutSuppr) return null
                return React.createElement('button', {
                  onClick: function(e) {
                    e.preventDefault()
                    e.stopPropagation()
                    supprimerTopic(activeForum.id, activeTopic.id)
                  },
                  title: 'Delete this message',
                  style: {
                    background: 'transparent', color: '#ef4444', border: 'none',
                    cursor: 'pointer', fontSize: '18px', padding: '6px 10px',
                    borderRadius: '8px', lineHeight: 1,
                    touchAction: 'manipulation',
                    WebkitTapHighlightColor: 'transparent'
                  }
                }, '🗑️')
              })()}
            </div>
            <p style={{ opacity: 0.5, fontSize: 13, marginBottom: 16 }}>by <strong>{activeTopic.author}</strong> · {activeTopic.date}</p>
            {activeTopic.content && <p style={{ fontSize: 15, lineHeight: 1.7 }}>{activeTopic.content}</p>}
            <div style={{ marginTop: 16, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
              <button className={'like-btn ' + (getLike((activeForum ? activeForum.id : '') + '-' + activeTopic.id).hasLiked ? 'liked' : '')} onClick={function() { toggleLike((activeForum ? activeForum.id : '') + '-' + activeTopic.id) }}>
                ❤️ {getLike((activeForum ? activeForum.id : '') + '-' + activeTopic.id).count || ''} Like
              </button>
              {(function() {
                var peutSuppr = (account && activeTopic.author &&
                  String(activeTopic.author).toLowerCase() === String(displayName(account)).toLowerCase())
                  || (account && String(account).toLowerCase() === SUPER_ADMIN.toLowerCase())
                if (!peutSuppr) return null
                return React.createElement('button', {
                  onClick: function(e) {
                    e.preventDefault()
                    e.stopPropagation()
                    supprimerTopic(activeForum.id, activeTopic.id)
                  },
                  style: {
                    background: '#ef4444', color: '#fff', border: 'none',
                    borderRadius: '12px', padding: '12px 24px',
                    fontSize: '14px', fontWeight: '600', cursor: 'pointer',
                    touchAction: 'manipulation',
                    WebkitTapHighlightColor: 'transparent'
                  }
                }, '🗑️ Delete this topic')
              })()}
            </div>
          </div>
          <h3 style={{ marginBottom: 16, opacity: 0.7 }}>
            {activeTopic.replies.length} repl{activeTopic.replies.length !== 1 ? 'ies' : 'y'}
          </h3>
          {activeTopic.replies.map(function(r) { return (
            <div key={r.id} style={{ borderRadius: 12, padding: '16px 20px', marginBottom: 12, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                <p style={{ fontSize: 13, opacity: 0.5, marginBottom: 8, flex: 1 }}><strong>{r.author}</strong> · {r.date}</p>
                {(function() {
                  var peutSuppr = (account && r.author &&
                    String(r.author).toLowerCase() === String(displayName(account)).toLowerCase())
                    || (account && String(account).toLowerCase() === SUPER_ADMIN.toLowerCase())
                  if (!peutSuppr) return null
                  return React.createElement('button', {
                    onClick: function(e) {
                      e.preventDefault()
                      e.stopPropagation()
                      supprimerReponse(activeForum.id, activeTopic.id, r.id)
                    },
                    title: 'Delete this reply',
                    style: {
                      background: 'transparent', color: '#ef4444', border: 'none',
                      cursor: 'pointer', fontSize: '16px', padding: '4px 8px',
                      borderRadius: '6px', lineHeight: 1,
                      touchAction: 'manipulation',
                      WebkitTapHighlightColor: 'transparent'
                    }
                  }, '🗑️')
                })()}
              </div>
              <p style={{ fontSize: 15, lineHeight: 1.6 }}>{r.content}</p>
              <button className={'like-btn ' + (getLike('reply-' + r.id).hasLiked ? 'liked' : '')} style={{ marginTop: 8 }} onClick={function() { toggleLike('reply-' + r.id) }}>
                ❤️ {getLike('reply-' + r.id).count || ''} Like
              </button>
            </div>
          )})}
          <div style={{ borderRadius: 14, padding: 24, marginTop: 24, background: dark ? '#161b22' : '#ffffff', border: '1.5px solid', borderColor: dark ? '#30363d' : '#e2e8f0' }}>
            <h3 style={{ marginBottom: 16 }}>✍️ Your reply</h3>
            {!account && <p style={{ opacity: 0.6, marginBottom: 12, fontSize: 14 }}>Connect MetaMask to reply</p>}
            {account && !estAbonne && <p style={{ color: '#f59e0b', marginBottom: 12, fontSize: 14 }}>Subscribe to reply</p>}
            <textarea value={newReply} onChange={function(e) { setNewReply(e.target.value) }} placeholder="Write your reply..." rows={4}
              style={inputStyleResize} disabled={!estAbonne} />
            <button className="btn btn-primary" onClick={posterReponse} style={{ padding: '12px 28px' }} disabled={!estAbonne || !account}>
              Post reply
            </button>
          </div>
        </div>
      )}

      {/* ══════════════ MODAL NOUVEAU SALON ══════════════ */}
      {showNewSalon && (
        <div style={{ position: 'fixed', inset: 0, background: '#0008', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: dark ? '#161b22' : 'white', borderRadius: 16, padding: 32, width: 420, border: '1.5px solid #6366f1' }}>
            <h2 style={{ marginBottom: 24, color: '#6366f1' }}>✨ New channel</h2>
            <label style={{ fontSize: 13, opacity: 0.7 }}>Emoji</label>
            <input value={newSalon.emoji} onChange={function(e) { setNewSalon(Object.assign({}, newSalon, { emoji: e.target.value })) }} style={inputStyle} placeholder="💡" />
            <label style={{ fontSize: 13, opacity: 0.7 }}>Name</label>
            <input value={newSalon.name} onChange={function(e) { setNewSalon(Object.assign({}, newSalon, { name: e.target.value })) }} style={inputStyle} placeholder="Ex: Science, Art..." />
            <label style={{ fontSize: 13, opacity: 0.7 }}>Description</label>
            <input value={newSalon.description} onChange={function(e) { setNewSalon(Object.assign({}, newSalon, { description: e.target.value })) }} style={inputStyle} placeholder="Short description" />
            <div style={{ display: 'flex', gap: 12 }}>
              <button className="btn btn-primary" onClick={creerSalon} style={{ flex: 1 }}>Create</button>
              <button className="btn btn-ghost" onClick={function() { setShowNewSalon(false) }} style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════ MODAL NOUVEAU TOPIC ══════════════ */}
      {showNewTopic && (
        <div style={{ position: 'fixed', inset: 0, background: '#0008', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: dark ? '#161b22' : 'white', borderRadius: 16, padding: 32, width: 500, border: '1.5px solid #6366f1' }}>
            <h2 style={{ marginBottom: 24, color: '#6366f1' }}>📝 New topic</h2>
            <label style={{ fontSize: 13, opacity: 0.7 }}>Title</label>
            <input value={newTopic.title} onChange={function(e) { setNewTopic(Object.assign({}, newTopic, { title: e.target.value })) }} style={inputStyle} placeholder="Title..." />
            <label style={{ fontSize: 13, opacity: 0.7 }}>Content</label>
            <textarea value={newTopic.content} onChange={function(e) { setNewTopic(Object.assign({}, newTopic, { content: e.target.value })) }} style={inputStyleResize} rows={4} placeholder="Elaborate..." />
            <div style={{ display: 'flex', gap: 12 }}>
              <button className="btn btn-primary" onClick={creerTopic} style={{ flex: 1 }}>Publish</button>
              <button className="btn btn-ghost" onClick={function() { setShowNewTopic(false) }} style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════ FOOTER ══════════════ */}
      <div className="footer">
        Blabla.Privacy © 2026 —{' '}
        <a href={`https://etherscan.io/address/${CONTRACT_ADDRESS}`} target="_blank" rel="noreferrer" style={{ color: '#6366f1' }}>
          Etherscan Contract
        </a>
        {' — '}
        <a href="https://zonefree.x" style={{ color: '#6366f1' }}>🌐 zonefree.x</a>
        {' — '}
        <a href="https://www.deepl.com/translator" target="_blank" rel="noopener noreferrer" style={{ color: '#00ffff' }}>🌐 DeepL</a>
      </div>

    </div>
  )
}

export { AppErrorBoundary }
export default App
